const useGetBrandTranslation = (brand) => {
  let en = require("./en.json");
  let de = require("./de.json");
  let ar = require("./ar.json");
  let es = require("./es.json");
  let fr = require("./fr.json");
  let he = require("./he.json");
  let it = require("./it.json");
  let ja = require("./ja.json");
  let ko = require("./ko.json");
  let my = require("./my.json");
  let pt = require("./pt.json");
  let ru = require("./ru.json");
  let th = require("./th.json");
  let tr = require("./tr.json");
  let vi = require("./vi.json");
  let zh = require("./zh.json");
  let nl = require("./nl.json");

  // add all languages
  en = Object.assign(en, require("./tos-en.json"));
  fr = Object.assign(fr, require("./tos-fr.json"));
  ja = Object.assign(ja, require("./tos-ja.json"));
  th = Object.assign(th, require("./tos-th.json"));
  zh = Object.assign(zh, require("./tos-zh.json"));
  pt = Object.assign(pt, require("./tos-pt.json"));
  tr = Object.assign(tr, require("./tos-tr.json"));
  ru = Object.assign(ru, require("./tos-ru.json"));
  es = Object.assign(es, require("./tos-es.json"));
  de = Object.assign(de, require("./tos-de.json"));
  ko = Object.assign(ko, require("./tos-ko.json"));
  ar = Object.assign(ar, require("./tos-ar.json"));
  my = Object.assign(my, require("./tos-my.json"));
  it = Object.assign(it, require("./tos-it.json"));
  vi = Object.assign(vi, require("./tos-vi.json"));
  he = Object.assign(he, require("./tos-he.json"));
  nl = Object.assign(nl, require("./tos-nl.json"));

  if (
    brand === "Akaryn Hotels" ||
    brand === "Akaryn Hotel Group"
  ) {
    en = Object.assign(en, require("./AKARYN/en.json"));
    fr = Object.assign(fr, require("./AKARYN/fr.json"));
    ja = Object.assign(ja, require("./AKARYN/ja.json"));
    th = Object.assign(th, require("./AKARYN/th.json"));
    zh = Object.assign(zh, require("./AKARYN/zh.json"));
    pt = Object.assign(pt, require("./AKARYN/pt.json"));
    tr = Object.assign(tr, require("./AKARYN/tr.json"));
    ru = Object.assign(ru, require("./AKARYN/ru.json"));
    es = Object.assign(es, require("./AKARYN/es.json"));
    de = Object.assign(de, require("./AKARYN/de.json"));
    ko = Object.assign(ko, require("./AKARYN/ko.json"));
    ar = Object.assign(ar, require("./AKARYN/ar.json"));
    my = Object.assign(my, require("./AKARYN/my.json"));
    it = Object.assign(it, require("./AKARYN/it.json"));
    vi = Object.assign(vi, require("./AKARYN/vi.json"));
    he = Object.assign(he, require("./AKARYN/he.json"));
    nl = Object.assign(nl, require("./AKARYN/nl.json"));

    en = Object.assign(en, require("./AKARYN/tos-en.json"));
    fr = Object.assign(fr, require("./AKARYN/tos-fr.json"));
    ja = Object.assign(ja, require("./AKARYN/tos-ja.json"));
    th = Object.assign(th, require("./AKARYN/tos-th.json"));
    zh = Object.assign(zh, require("./AKARYN/tos-zh.json"));
    pt = Object.assign(pt, require("./AKARYN/tos-pt.json"));
    tr = Object.assign(tr, require("./AKARYN/tos-tr.json"));
    ru = Object.assign(ru, require("./AKARYN/tos-ru.json"));
    es = Object.assign(es, require("./AKARYN/tos-es.json"));
    de = Object.assign(de, require("./AKARYN/tos-de.json"));
    ko = Object.assign(ko, require("./AKARYN/tos-ko.json"));
    ar = Object.assign(ar, require("./AKARYN/tos-ar.json"));
    my = Object.assign(my, require("./AKARYN/tos-my.json"));
    it = Object.assign(it, require("./AKARYN/tos-it.json"));
    vi = Object.assign(vi, require("./AKARYN/tos-vi.json"));
    he = Object.assign(he, require("./AKARYN/tos-he.json"));
    nl = Object.assign(nl, require("./AKARYN/tos-nl.json"));
  } else if (
    brand === "Chatrium Hotels" ||
    brand === "Chatrium Hospitality"
  ) {
    en = Object.assign(en, require("./CHATRIUM/en.json"));
    fr = Object.assign(fr, require("./CHATRIUM/fr.json"));
    ja = Object.assign(ja, require("./CHATRIUM/ja.json"));
    th = Object.assign(th, require("./CHATRIUM/th.json"));
    zh = Object.assign(zh, require("./CHATRIUM/zh.json"));
    pt = Object.assign(pt, require("./CHATRIUM/pt.json"));
    tr = Object.assign(tr, require("./CHATRIUM/tr.json"));
    ru = Object.assign(ru, require("./CHATRIUM/ru.json"));
    es = Object.assign(es, require("./CHATRIUM/es.json"));
    de = Object.assign(de, require("./CHATRIUM/de.json"));
    ko = Object.assign(ko, require("./CHATRIUM/ko.json"));
    ar = Object.assign(ar, require("./CHATRIUM/ar.json"));
    my = Object.assign(my, require("./CHATRIUM/my.json"));
    it = Object.assign(it, require("./CHATRIUM/it.json"));
    vi = Object.assign(vi, require("./CHATRIUM/vi.json"));
    he = Object.assign(he, require("./CHATRIUM/he.json"));
    nl = Object.assign(nl, require("./CHATRIUM/nl.json"));

    en = Object.assign(en, require("./CHATRIUM/tos-en.json"));
    fr = Object.assign(fr, require("./CHATRIUM/tos-fr.json"));
    ja = Object.assign(ja, require("./CHATRIUM/tos-ja.json"));
    th = Object.assign(th, require("./CHATRIUM/tos-th.json"));
    zh = Object.assign(zh, require("./CHATRIUM/tos-zh.json"));
    pt = Object.assign(pt, require("./CHATRIUM/tos-pt.json"));
    tr = Object.assign(tr, require("./CHATRIUM/tos-tr.json"));
    ru = Object.assign(ru, require("./CHATRIUM/tos-ru.json"));
    es = Object.assign(es, require("./CHATRIUM/tos-es.json"));
    de = Object.assign(de, require("./CHATRIUM/tos-de.json"));
    ko = Object.assign(ko, require("./CHATRIUM/tos-ko.json"));
    ar = Object.assign(ar, require("./CHATRIUM/tos-ar.json"));
    my = Object.assign(my, require("./CHATRIUM/tos-my.json"));
    it = Object.assign(it, require("./CHATRIUM/tos-it.json"));
    vi = Object.assign(vi, require("./CHATRIUM/tos-vi.json"));
    he = Object.assign(he, require("./CHATRIUM/tos-he.json"));
    nl = Object.assign(nl, require("./CHATRIUM/tos-nl.json"));
  } else if (
    brand === "SIX SENSES" ||
    brand === "Six Senses" ||
    brand === "SIX SENSES ENTERPRISE"
  ) {
    en = Object.assign(en, require("./SIX_SENSES/en.json"));
    fr = Object.assign(fr, require("./SIX_SENSES/fr.json"));
    ja = Object.assign(ja, require("./SIX_SENSES/ja.json"));
    th = Object.assign(th, require("./SIX_SENSES/th.json"));
    zh = Object.assign(zh, require("./SIX_SENSES/zh.json"));
    pt = Object.assign(pt, require("./SIX_SENSES/pt.json"));
    tr = Object.assign(tr, require("./SIX_SENSES/tr.json"));
    ru = Object.assign(ru, require("./SIX_SENSES/ru.json"));
    es = Object.assign(es, require("./SIX_SENSES/es.json"));
    de = Object.assign(de, require("./SIX_SENSES/de.json"));
    ko = Object.assign(ko, require("./SIX_SENSES/ko.json"));
    ar = Object.assign(ar, require("./SIX_SENSES/ar.json"));
    my = Object.assign(my, require("./SIX_SENSES/my.json"));
    it = Object.assign(it, require("./SIX_SENSES/it.json"));
    vi = Object.assign(vi, require("./SIX_SENSES/vi.json"));
    he = Object.assign(he, require("./SIX_SENSES/he.json"));
    nl = Object.assign(nl, require("./SIX_SENSES/nl.json"));

    en = Object.assign(en, require("./SIX_SENSES/tos-en.json"));
    fr = Object.assign(fr, require("./SIX_SENSES/tos-fr.json"));
    ja = Object.assign(ja, require("./SIX_SENSES/tos-ja.json"));
    th = Object.assign(th, require("./SIX_SENSES/tos-th.json"));
    zh = Object.assign(zh, require("./SIX_SENSES/tos-zh.json"));
    pt = Object.assign(pt, require("./SIX_SENSES/tos-pt.json"));
    tr = Object.assign(tr, require("./SIX_SENSES/tos-tr.json"));
    ru = Object.assign(ru, require("./SIX_SENSES/tos-ru.json"));
    es = Object.assign(es, require("./SIX_SENSES/tos-es.json"));
    de = Object.assign(de, require("./SIX_SENSES/tos-de.json"));
    ko = Object.assign(ko, require("./SIX_SENSES/tos-ko.json"));
    ar = Object.assign(ar, require("./SIX_SENSES/tos-ar.json"));
    my = Object.assign(my, require("./SIX_SENSES/tos-my.json"));
    it = Object.assign(it, require("./SIX_SENSES/tos-it.json"));
    vi = Object.assign(vi, require("./SIX_SENSES/tos-vi.json"));
    he = Object.assign(he, require("./SIX_SENSES/tos-he.json"));
    nl = Object.assign(nl, require("./SIX_SENSES/tos-nl.json"));
  } else if (brand === "Jono Hotels" || brand === "JONO") {
    en = Object.assign(en, require("./JONO/en.json"));
    fr = Object.assign(fr, require("./JONO/fr.json"));
    ja = Object.assign(ja, require("./JONO/ja.json"));
    th = Object.assign(th, require("./JONO/th.json"));
    zh = Object.assign(zh, require("./JONO/zh.json"));
    pt = Object.assign(pt, require("./JONO/pt.json"));
    tr = Object.assign(tr, require("./JONO/tr.json"));
    ru = Object.assign(ru, require("./JONO/ru.json"));
    es = Object.assign(es, require("./JONO/es.json"));
    de = Object.assign(de, require("./JONO/de.json"));
    ko = Object.assign(ko, require("./JONO/ko.json"));
    ar = Object.assign(ar, require("./JONO/ar.json"));
    my = Object.assign(my, require("./JONO/my.json"));
    it = Object.assign(it, require("./JONO/it.json"));
    vi = Object.assign(vi, require("./JONO/vi.json"));
    he = Object.assign(he, require("./JONO/he.json"));
    nl = Object.assign(nl, require("./JONO/nl.json"));

    en = Object.assign(en, require("./JONO/tos-en.json"));
    fr = Object.assign(fr, require("./JONO/tos-fr.json"));
    ja = Object.assign(ja, require("./JONO/tos-ja.json"));
    th = Object.assign(th, require("./JONO/tos-th.json"));
    zh = Object.assign(zh, require("./JONO/tos-zh.json"));
    pt = Object.assign(pt, require("./JONO/tos-pt.json"));
    tr = Object.assign(tr, require("./JONO/tos-tr.json"));
    ru = Object.assign(ru, require("./JONO/tos-ru.json"));
    es = Object.assign(es, require("./JONO/tos-es.json"));
    de = Object.assign(de, require("./JONO/tos-de.json"));
    ko = Object.assign(ko, require("./JONO/tos-ko.json"));
    ar = Object.assign(ar, require("./JONO/tos-ar.json"));
    my = Object.assign(my, require("./JONO/tos-my.json"));
    it = Object.assign(it, require("./JONO/tos-it.json"));
    vi = Object.assign(vi, require("./JONO/tos-vi.json"));
    he = Object.assign(he, require("./JONO/tos-he.json"));
    nl = Object.assign(nl, require("./JONO/tos-nl.json"));
  } else if (
    brand === "Kimpton Naranta Bali" ||
    brand === "Kimpton"
  ) {
    en = Object.assign(en, require("./KIMPTON/en.json"));
    fr = Object.assign(fr, require("./KIMPTON/fr.json"));
    ja = Object.assign(ja, require("./KIMPTON/ja.json"));
    th = Object.assign(th, require("./KIMPTON/th.json"));
    zh = Object.assign(zh, require("./KIMPTON/zh.json"));
    pt = Object.assign(pt, require("./KIMPTON/pt.json"));
    tr = Object.assign(tr, require("./KIMPTON/tr.json"));
    ru = Object.assign(ru, require("./KIMPTON/ru.json"));
    es = Object.assign(es, require("./KIMPTON/es.json"));
    de = Object.assign(de, require("./KIMPTON/de.json"));
    ko = Object.assign(ko, require("./KIMPTON/ko.json"));
    ar = Object.assign(ar, require("./KIMPTON/ar.json"));
    my = Object.assign(my, require("./KIMPTON/my.json"));
    it = Object.assign(it, require("./KIMPTON/it.json"));
    vi = Object.assign(vi, require("./KIMPTON/vi.json"));
    he = Object.assign(he, require("./KIMPTON/he.json"));
    nl = Object.assign(nl, require("./KIMPTON/nl.json"));

    en = Object.assign(en, require("./KIMPTON/tos-en.json"));
    fr = Object.assign(fr, require("./KIMPTON/tos-fr.json"));
    ja = Object.assign(ja, require("./KIMPTON/tos-ja.json"));
    th = Object.assign(th, require("./KIMPTON/tos-th.json"));
    zh = Object.assign(zh, require("./KIMPTON/tos-zh.json"));
    pt = Object.assign(pt, require("./KIMPTON/tos-pt.json"));
    tr = Object.assign(tr, require("./KIMPTON/tos-tr.json"));
    ru = Object.assign(ru, require("./KIMPTON/tos-ru.json"));
    es = Object.assign(es, require("./KIMPTON/tos-es.json"));
    de = Object.assign(de, require("./KIMPTON/tos-de.json"));
    ko = Object.assign(ko, require("./KIMPTON/tos-ko.json"));
    ar = Object.assign(ar, require("./KIMPTON/tos-ar.json"));
    my = Object.assign(my, require("./KIMPTON/tos-my.json"));
    it = Object.assign(it, require("./KIMPTON/tos-it.json"));
    vi = Object.assign(vi, require("./KIMPTON/tos-vi.json"));
    he = Object.assign(he, require("./KIMPTON/tos-he.json"));
    nl = Object.assign(nl, require("./KIMPTON/tos-nl.json"));
  } else if (brand === "RAKxa") {
    en = Object.assign(en, require("./RAKXA/en.json"));
    fr = Object.assign(fr, require("./RAKXA/fr.json"));
    ja = Object.assign(ja, require("./RAKXA/ja.json"));
    th = Object.assign(th, require("./RAKXA/th.json"));
    zh = Object.assign(zh, require("./RAKXA/zh.json"));
    pt = Object.assign(pt, require("./RAKXA/pt.json"));
    tr = Object.assign(tr, require("./RAKXA/tr.json"));
    ru = Object.assign(ru, require("./RAKXA/ru.json"));
    es = Object.assign(es, require("./RAKXA/es.json"));
    de = Object.assign(de, require("./RAKXA/de.json"));
    ko = Object.assign(ko, require("./RAKXA/ko.json"));
    ar = Object.assign(ar, require("./RAKXA/ar.json"));
    my = Object.assign(my, require("./RAKXA/my.json"));
    it = Object.assign(it, require("./RAKXA/it.json"));
    vi = Object.assign(vi, require("./RAKXA/vi.json"));
    he = Object.assign(he, require("./RAKXA/he.json"));
    nl = Object.assign(nl, require("./RAKXA/nl.json"));

    en = Object.assign(en, require("./RAKXA/tos-en.json"));
    fr = Object.assign(fr, require("./RAKXA/tos-fr.json"));
    ja = Object.assign(ja, require("./RAKXA/tos-ja.json"));
    th = Object.assign(th, require("./RAKXA/tos-th.json"));
    zh = Object.assign(zh, require("./RAKXA/tos-zh.json"));
    pt = Object.assign(pt, require("./RAKXA/tos-pt.json"));
    tr = Object.assign(tr, require("./RAKXA/tos-tr.json"));
    ru = Object.assign(ru, require("./RAKXA/tos-ru.json"));
    es = Object.assign(es, require("./RAKXA/tos-es.json"));
    de = Object.assign(de, require("./RAKXA/tos-de.json"));
    ko = Object.assign(ko, require("./RAKXA/tos-ko.json"));
    ar = Object.assign(ar, require("./RAKXA/tos-ar.json"));
    my = Object.assign(my, require("./RAKXA/tos-my.json"));
    it = Object.assign(it, require("./RAKXA/tos-it.json"));
    vi = Object.assign(vi, require("./RAKXA/tos-vi.json"));
    he = Object.assign(he, require("./RAKXA/tos-he.json"));
    nl = Object.assign(nl, require("./RAKXA/tos-nl.json"));
  } else if (
    brand === "Anantara Hotels" ||
    brand === "Anantara" ||
    brand === "Anantara Hotels, Resorts & Spas"
  ) {
    en = Object.assign(en, require("./ANANTARA/en.json"));
    fr = Object.assign(fr, require("./ANANTARA/fr.json"));
    ja = Object.assign(ja, require("./ANANTARA/ja.json"));
    th = Object.assign(th, require("./ANANTARA/th.json"));
    zh = Object.assign(zh, require("./ANANTARA/zh.json"));
    pt = Object.assign(pt, require("./ANANTARA/pt.json"));
    tr = Object.assign(tr, require("./ANANTARA/tr.json"));
    ru = Object.assign(ru, require("./ANANTARA/ru.json"));
    es = Object.assign(es, require("./ANANTARA/es.json"));
    de = Object.assign(de, require("./ANANTARA/de.json"));
    ko = Object.assign(ko, require("./ANANTARA/ko.json"));
    ar = Object.assign(ar, require("./ANANTARA/ar.json"));
    my = Object.assign(my, require("./ANANTARA/my.json"));
    it = Object.assign(it, require("./ANANTARA/it.json"));
    vi = Object.assign(vi, require("./ANANTARA/vi.json"));
    he = Object.assign(he, require("./ANANTARA/he.json"));
    nl = Object.assign(nl, require("./ANANTARA/nl.json"));

    en = Object.assign(en, require("./ANANTARA/tos-en.json"));
    fr = Object.assign(fr, require("./ANANTARA/tos-fr.json"));
    ja = Object.assign(ja, require("./ANANTARA/tos-ja.json"));
    th = Object.assign(th, require("./ANANTARA/tos-th.json"));
    zh = Object.assign(zh, require("./ANANTARA/tos-zh.json"));
    pt = Object.assign(pt, require("./ANANTARA/tos-pt.json"));
    tr = Object.assign(tr, require("./ANANTARA/tos-tr.json"));
    ru = Object.assign(ru, require("./ANANTARA/tos-ru.json"));
    es = Object.assign(es, require("./ANANTARA/tos-es.json"));
    de = Object.assign(de, require("./ANANTARA/tos-de.json"));
    ko = Object.assign(ko, require("./ANANTARA/tos-ko.json"));
    ar = Object.assign(ar, require("./ANANTARA/tos-ar.json"));
    my = Object.assign(my, require("./ANANTARA/tos-my.json"));
    it = Object.assign(it, require("./ANANTARA/tos-it.json"));
    vi = Object.assign(vi, require("./ANANTARA/tos-vi.json"));
    he = Object.assign(he, require("./ANANTARA/tos-he.json"));
    nl = Object.assign(nl, require("./ANANTARA/tos-nl.json"));
  } else if (brand === "Freedom") {
    en = Object.assign(en, require("./FREEDOM/en.json"));
    fr = Object.assign(fr, require("./FREEDOM/fr.json"));
    ja = Object.assign(ja, require("./FREEDOM/ja.json"));
    th = Object.assign(th, require("./FREEDOM/th.json"));
    zh = Object.assign(zh, require("./FREEDOM/zh.json"));
    pt = Object.assign(pt, require("./FREEDOM/pt.json"));
    tr = Object.assign(tr, require("./FREEDOM/tr.json"));
    ru = Object.assign(ru, require("./FREEDOM/ru.json"));
    es = Object.assign(es, require("./FREEDOM/es.json"));
    de = Object.assign(de, require("./FREEDOM/de.json"));
    ko = Object.assign(ko, require("./FREEDOM/ko.json"));
    ar = Object.assign(ar, require("./FREEDOM/ar.json"));
    my = Object.assign(my, require("./FREEDOM/my.json"));
    it = Object.assign(it, require("./FREEDOM/it.json"));
    vi = Object.assign(vi, require("./FREEDOM/vi.json"));
    he = Object.assign(he, require("./FREEDOM/he.json"));
    nl = Object.assign(nl, require("./FREEDOM/nl.json"));

    en = Object.assign(en, require("./FREEDOM/tos-en.json"));
    fr = Object.assign(fr, require("./FREEDOM/tos-fr.json"));
    ja = Object.assign(ja, require("./FREEDOM/tos-ja.json"));
    th = Object.assign(th, require("./FREEDOM/tos-th.json"));
    zh = Object.assign(zh, require("./FREEDOM/tos-zh.json"));
    pt = Object.assign(pt, require("./FREEDOM/tos-pt.json"));
    tr = Object.assign(tr, require("./FREEDOM/tos-tr.json"));
    ru = Object.assign(ru, require("./FREEDOM/tos-ru.json"));
    es = Object.assign(es, require("./FREEDOM/tos-es.json"));
    de = Object.assign(de, require("./FREEDOM/tos-de.json"));
    ko = Object.assign(ko, require("./FREEDOM/tos-ko.json"));
    ar = Object.assign(ar, require("./FREEDOM/tos-ar.json"));
    my = Object.assign(my, require("./FREEDOM/tos-my.json"));
    it = Object.assign(it, require("./FREEDOM/tos-it.json"));
    vi = Object.assign(vi, require("./FREEDOM/tos-vi.json"));
    he = Object.assign(he, require("./FREEDOM/tos-he.json"));
    nl = Object.assign(nl, require("./FREEDOM/tos-nl.json"));
  } else if (
    brand === "AVANI Hotels" ||
    brand === "Avani Hotels & Resorts"
  ) {
    en = Object.assign(en, require("./AVANI/en.json"));
    fr = Object.assign(fr, require("./AVANI/fr.json"));
    ja = Object.assign(ja, require("./AVANI/ja.json"));
    th = Object.assign(th, require("./AVANI/th.json"));
    zh = Object.assign(zh, require("./AVANI/zh.json"));
    pt = Object.assign(pt, require("./AVANI/pt.json"));
    tr = Object.assign(tr, require("./AVANI/tr.json"));
    ru = Object.assign(ru, require("./AVANI/ru.json"));
    es = Object.assign(es, require("./AVANI/es.json"));
    de = Object.assign(de, require("./AVANI/de.json"));
    ko = Object.assign(ko, require("./AVANI/ko.json"));
    ar = Object.assign(ar, require("./AVANI/ar.json"));
    my = Object.assign(my, require("./AVANI/my.json"));
    it = Object.assign(it, require("./AVANI/it.json"));
    vi = Object.assign(vi, require("./AVANI/vi.json"));
    he = Object.assign(he, require("./AVANI/he.json"));
    nl = Object.assign(nl, require("./AVANI/nl.json"));

    en = Object.assign(en, require("./AVANI/tos-en.json"));
    fr = Object.assign(fr, require("./AVANI/tos-fr.json"));
    ja = Object.assign(ja, require("./AVANI/tos-ja.json"));
    th = Object.assign(th, require("./AVANI/tos-th.json"));
    zh = Object.assign(zh, require("./AVANI/tos-zh.json"));
    pt = Object.assign(pt, require("./AVANI/tos-pt.json"));
    tr = Object.assign(tr, require("./AVANI/tos-tr.json"));
    ru = Object.assign(ru, require("./AVANI/tos-ru.json"));
    es = Object.assign(es, require("./AVANI/tos-es.json"));
    de = Object.assign(de, require("./AVANI/tos-de.json"));
    ko = Object.assign(ko, require("./AVANI/tos-ko.json"));
    ar = Object.assign(ar, require("./AVANI/tos-ar.json"));
    my = Object.assign(my, require("./AVANI/tos-my.json"));
    it = Object.assign(it, require("./AVANI/tos-it.json"));
    vi = Object.assign(vi, require("./AVANI/tos-vi.json"));
    he = Object.assign(he, require("./AVANI/tos-he.json"));
    nl = Object.assign(nl, require("./AVANI/tos-nl.json"));
  } else if (
    brand === "Kurumba" ||
    brand === "Universal Resorts"
  ) {
    en = Object.assign(en, require("./KURUMBA/en.json"));
    fr = Object.assign(fr, require("./KURUMBA/fr.json"));
    ja = Object.assign(ja, require("./KURUMBA/ja.json"));
    th = Object.assign(th, require("./KURUMBA/th.json"));
    zh = Object.assign(zh, require("./KURUMBA/zh.json"));
    pt = Object.assign(pt, require("./KURUMBA/pt.json"));
    tr = Object.assign(tr, require("./KURUMBA/tr.json"));
    ru = Object.assign(ru, require("./KURUMBA/ru.json"));
    es = Object.assign(es, require("./KURUMBA/es.json"));
    de = Object.assign(de, require("./KURUMBA/de.json"));
    ko = Object.assign(ko, require("./KURUMBA/ko.json"));
    ar = Object.assign(ar, require("./KURUMBA/ar.json"));
    my = Object.assign(my, require("./KURUMBA/my.json"));
    it = Object.assign(it, require("./KURUMBA/it.json"));
    vi = Object.assign(vi, require("./KURUMBA/vi.json"));
    he = Object.assign(he, require("./KURUMBA/he.json"));
    nl = Object.assign(nl, require("./KURUMBA/nl.json"));

    en = Object.assign(en, require("./KURUMBA/tos-en.json"));
    fr = Object.assign(fr, require("./KURUMBA/tos-fr.json"));
    ja = Object.assign(ja, require("./KURUMBA/tos-ja.json"));
    th = Object.assign(th, require("./KURUMBA/tos-th.json"));
    zh = Object.assign(zh, require("./KURUMBA/tos-zh.json"));
    pt = Object.assign(pt, require("./KURUMBA/tos-pt.json"));
    tr = Object.assign(tr, require("./KURUMBA/tos-tr.json"));
    ru = Object.assign(ru, require("./KURUMBA/tos-ru.json"));
    es = Object.assign(es, require("./KURUMBA/tos-es.json"));
    de = Object.assign(de, require("./KURUMBA/tos-de.json"));
    ko = Object.assign(ko, require("./KURUMBA/tos-ko.json"));
    ar = Object.assign(ar, require("./KURUMBA/tos-ar.json"));
    my = Object.assign(my, require("./KURUMBA/tos-my.json"));
    it = Object.assign(it, require("./KURUMBA/tos-it.json"));
    vi = Object.assign(vi, require("./KURUMBA/tos-vi.json"));
    he = Object.assign(he, require("./KURUMBA/tos-he.json"));
    nl = Object.assign(nl, require("./KURUMBA/tos-nl.json"));
  } else if (
    brand === "Sodales Hotels" ||
    brand === "Sodales"
  ) {
    en = Object.assign(en, require("./SODALES/en.json"));
    fr = Object.assign(fr, require("./SODALES/fr.json"));
    ja = Object.assign(ja, require("./SODALES/ja.json"));
    th = Object.assign(th, require("./SODALES/th.json"));
    zh = Object.assign(zh, require("./SODALES/zh.json"));
    pt = Object.assign(pt, require("./SODALES/pt.json"));
    tr = Object.assign(tr, require("./SODALES/tr.json"));
    ru = Object.assign(ru, require("./SODALES/ru.json"));
    es = Object.assign(es, require("./SODALES/es.json"));
    de = Object.assign(de, require("./SODALES/de.json"));
    ko = Object.assign(ko, require("./SODALES/ko.json"));
    ar = Object.assign(ar, require("./SODALES/ar.json"));
    my = Object.assign(my, require("./SODALES/my.json"));
    it = Object.assign(it, require("./SODALES/it.json"));
    vi = Object.assign(vi, require("./SODALES/vi.json"));
    he = Object.assign(he, require("./SODALES/he.json"));
    nl = Object.assign(nl, require("./SODALES/nl.json"));

    en = Object.assign(en, require("./SODALES/tos-en.json"));
    fr = Object.assign(fr, require("./SODALES/tos-fr.json"));
    ja = Object.assign(ja, require("./SODALES/tos-ja.json"));
    th = Object.assign(th, require("./SODALES/tos-th.json"));
    zh = Object.assign(zh, require("./SODALES/tos-zh.json"));
    pt = Object.assign(pt, require("./SODALES/tos-pt.json"));
    tr = Object.assign(tr, require("./SODALES/tos-tr.json"));
    ru = Object.assign(ru, require("./SODALES/tos-ru.json"));
    es = Object.assign(es, require("./SODALES/tos-es.json"));
    de = Object.assign(de, require("./SODALES/tos-de.json"));
    ko = Object.assign(ko, require("./SODALES/tos-ko.json"));
    ar = Object.assign(ar, require("./SODALES/tos-ar.json"));
    my = Object.assign(my, require("./SODALES/tos-my.json"));
    it = Object.assign(it, require("./SODALES/tos-it.json"));
    vi = Object.assign(vi, require("./SODALES/tos-vi.json"));
    he = Object.assign(he, require("./SODALES/tos-he.json"));
    nl = Object.assign(nl, require("./SODALES/tos-nl.json"));
  } else if (brand === "Wave Hotel") {
    en = Object.assign(en, require("./TAVISTOCK/en.json"));
    fr = Object.assign(fr, require("./TAVISTOCK/fr.json"));
    ja = Object.assign(ja, require("./TAVISTOCK/ja.json"));
    th = Object.assign(th, require("./TAVISTOCK/th.json"));
    zh = Object.assign(zh, require("./TAVISTOCK/zh.json"));
    pt = Object.assign(pt, require("./TAVISTOCK/pt.json"));
    tr = Object.assign(tr, require("./TAVISTOCK/tr.json"));
    ru = Object.assign(ru, require("./TAVISTOCK/ru.json"));
    es = Object.assign(es, require("./TAVISTOCK/es.json"));
    de = Object.assign(de, require("./TAVISTOCK/de.json"));
    ko = Object.assign(ko, require("./TAVISTOCK/ko.json"));
    ar = Object.assign(ar, require("./TAVISTOCK/ar.json"));
    my = Object.assign(my, require("./TAVISTOCK/my.json"));
    it = Object.assign(it, require("./TAVISTOCK/it.json"));
    vi = Object.assign(vi, require("./TAVISTOCK/vi.json"));
    he = Object.assign(he, require("./TAVISTOCK/he.json"));
    nl = Object.assign(nl, require("./TAVISTOCK/nl.json"));

    en = Object.assign(en, require("./TAVISTOCK/tos-en.json"));
    fr = Object.assign(fr, require("./TAVISTOCK/tos-fr.json"));
    ja = Object.assign(ja, require("./TAVISTOCK/tos-ja.json"));
    th = Object.assign(th, require("./TAVISTOCK/tos-th.json"));
    zh = Object.assign(zh, require("./TAVISTOCK/tos-zh.json"));
    pt = Object.assign(pt, require("./TAVISTOCK/tos-pt.json"));
    tr = Object.assign(tr, require("./TAVISTOCK/tos-ru.json"));
    es = Object.assign(es, require("./TAVISTOCK/tos-es.json"));
    de = Object.assign(de, require("./TAVISTOCK/tos-de.json"));
    ko = Object.assign(ko, require("./TAVISTOCK/tos-ko.json"));
    ar = Object.assign(ar, require("./TAVISTOCK/tos-ar.json"));
    my = Object.assign(my, require("./TAVISTOCK/tos-my.json"));
    it = Object.assign(it, require("./TAVISTOCK/tos-it.json"));
    vi = Object.assign(vi, require("./TAVISTOCK/tos-vi.json"));
    he = Object.assign(he, require("./TAVISTOCK/tos-he.json"));
    nl = Object.assign(nl, require("./TAVISTOCK/tos-nl.json"));
  } else if (brand === "Nu Chapter Hotels") {
    en = Object.assign(en, require("./NU_CHAPTER/en.json"));
    fr = Object.assign(fr, require("./NU_CHAPTER/fr.json"));
    ja = Object.assign(ja, require("./NU_CHAPTER/ja.json"));
    th = Object.assign(th, require("./NU_CHAPTER/th.json"));
    zh = Object.assign(zh, require("./NU_CHAPTER/zh.json"));
    pt = Object.assign(pt, require("./NU_CHAPTER/pt.json"));
    tr = Object.assign(tr, require("./NU_CHAPTER/tr.json"));
    ru = Object.assign(ru, require("./NU_CHAPTER/ru.json"));
    es = Object.assign(es, require("./NU_CHAPTER/es.json"));
    de = Object.assign(de, require("./NU_CHAPTER/de.json"));
    ko = Object.assign(ko, require("./NU_CHAPTER/ko.json"));
    ar = Object.assign(ar, require("./NU_CHAPTER/ar.json"));
    my = Object.assign(my, require("./NU_CHAPTER/my.json"));
    it = Object.assign(it, require("./NU_CHAPTER/it.json"));
    vi = Object.assign(vi, require("./NU_CHAPTER/vi.json"));
    he = Object.assign(he, require("./NU_CHAPTER/he.json"));
    nl = Object.assign(nl, require("./NU_CHAPTER/nl.json"));

    en = Object.assign(en, require("./NU_CHAPTER/tos-en.json"));
    fr = Object.assign(fr, require("./NU_CHAPTER/tos-fr.json"));
    ja = Object.assign(ja, require("./NU_CHAPTER/tos-ja.json"));
    th = Object.assign(th, require("./NU_CHAPTER/tos-th.json"));
    zh = Object.assign(zh, require("./NU_CHAPTER/tos-zh.json"));
    pt = Object.assign(pt, require("./NU_CHAPTER/tos-pt.json"));
    tr = Object.assign(tr, require("./NU_CHAPTER/tos-tr.json"));
    ru = Object.assign(ru, require("./NU_CHAPTER/tos-ru.json"));
    es = Object.assign(es, require("./NU_CHAPTER/tos-es.json"));
    de = Object.assign(de, require("./NU_CHAPTER/tos-de.json"));
    ko = Object.assign(ko, require("./NU_CHAPTER/tos-ko.json"));
    ar = Object.assign(ar, require("./NU_CHAPTER/tos-ar.json"));
    my = Object.assign(my, require("./NU_CHAPTER/tos-my.json"));
    it = Object.assign(it, require("./NU_CHAPTER/tos-it.json"));
    vi = Object.assign(vi, require("./NU_CHAPTER/tos-vi.json"));
    he = Object.assign(he, require("./NU_CHAPTER/tos-he.json"));
    nl = Object.assign(nl, require("./NU_CHAPTER/tos-nl.json"));
  } else if (brand === "The Largo" || brand === "Largo") {
    en = Object.assign(en, require("./LARGO/en.json"));
    fr = Object.assign(fr, require("./LARGO/fr.json"));
    ja = Object.assign(ja, require("./LARGO/ja.json"));
    th = Object.assign(th, require("./LARGO/th.json"));
    zh = Object.assign(zh, require("./LARGO/zh.json"));
    pt = Object.assign(pt, require("./LARGO/pt.json"));
    tr = Object.assign(tr, require("./LARGO/tr.json"));
    ru = Object.assign(ru, require("./LARGO/ru.json"));
    es = Object.assign(es, require("./LARGO/es.json"));
    de = Object.assign(de, require("./LARGO/de.json"));
    ko = Object.assign(ko, require("./LARGO/ko.json"));
    ar = Object.assign(ar, require("./LARGO/ar.json"));
    my = Object.assign(my, require("./LARGO/my.json"));
    it = Object.assign(it, require("./LARGO/it.json"));
    vi = Object.assign(vi, require("./LARGO/vi.json"));
    he = Object.assign(he, require("./LARGO/he.json"));
    nl = Object.assign(nl, require("./LARGO/nl.json"));

    en = Object.assign(en, require("./LARGO/tos-en.json"));
    fr = Object.assign(fr, require("./LARGO/tos-fr.json"));
    ja = Object.assign(ja, require("./LARGO/tos-ja.json"));
    th = Object.assign(th, require("./LARGO/tos-th.json"));
    zh = Object.assign(zh, require("./LARGO/tos-zh.json"));
    pt = Object.assign(pt, require("./LARGO/tos-pt.json"));
    tr = Object.assign(tr, require("./LARGO/tos-tr.json"));
    ru = Object.assign(ru, require("./LARGO/tos-ru.json"));
    es = Object.assign(es, require("./LARGO/tos-es.json"));
    de = Object.assign(de, require("./LARGO/tos-de.json"));
    ko = Object.assign(ko, require("./LARGO/tos-ko.json"));
    ar = Object.assign(ar, require("./LARGO/tos-ar.json"));
    my = Object.assign(my, require("./LARGO/tos-my.json"));
    it = Object.assign(it, require("./LARGO/tos-it.json"));
    vi = Object.assign(vi, require("./LARGO/tos-vi.json"));
    he = Object.assign(he, require("./LARGO/tos-he.json"));
    nl = Object.assign(nl, require("./LARGO/tos-nl.json"));
  } else if (
    brand === "OKKAMI" ||
    brand === "Okkami Brand"
  ) {
    en = Object.assign(en, require("./OKKAMI/en.json"));
    fr = Object.assign(fr, require("./OKKAMI/fr.json"));
    ja = Object.assign(ja, require("./OKKAMI/ja.json"));
    th = Object.assign(th, require("./OKKAMI/th.json"));
    zh = Object.assign(zh, require("./OKKAMI/zh.json"));
    pt = Object.assign(pt, require("./OKKAMI/pt.json"));
    tr = Object.assign(tr, require("./OKKAMI/tr.json"));
    ru = Object.assign(ru, require("./OKKAMI/ru.json"));
    es = Object.assign(es, require("./OKKAMI/es.json"));
    de = Object.assign(de, require("./OKKAMI/de.json"));
    ko = Object.assign(ko, require("./OKKAMI/ko.json"));
    ar = Object.assign(ar, require("./OKKAMI/ar.json"));
    my = Object.assign(my, require("./OKKAMI/my.json"));
    it = Object.assign(it, require("./OKKAMI/it.json"));
    vi = Object.assign(vi, require("./OKKAMI/vi.json"));
    he = Object.assign(he, require("./OKKAMI/he.json"));
    nl = Object.assign(nl, require("./OKKAMI/nl.json"));

    en = Object.assign(en, require("./OKKAMI/tos-en.json"));
    fr = Object.assign(fr, require("./OKKAMI/tos-fr.json"));
    ja = Object.assign(ja, require("./OKKAMI/tos-ja.json"));
    th = Object.assign(th, require("./OKKAMI/tos-th.json"));
    zh = Object.assign(zh, require("./OKKAMI/tos-zh.json"));
    pt = Object.assign(pt, require("./OKKAMI/tos-pt.json"));
    tr = Object.assign(tr, require("./OKKAMI/tos-tr.json"));
    ru = Object.assign(ru, require("./OKKAMI/tos-ru.json"));
    es = Object.assign(es, require("./OKKAMI/tos-es.json"));
    de = Object.assign(de, require("./OKKAMI/tos-de.json"));
    ko = Object.assign(ko, require("./OKKAMI/tos-ko.json"));
    ar = Object.assign(ar, require("./OKKAMI/tos-ar.json"));
    my = Object.assign(my, require("./OKKAMI/tos-my.json"));
    it = Object.assign(it, require("./OKKAMI/tos-it.json"));
    vi = Object.assign(vi, require("./OKKAMI/tos-vi.json"));
    he = Object.assign(he, require("./OKKAMI/tos-he.json"));
    nl = Object.assign(nl, require("./OKKAMI/tos-nl.json"));
  } else if (
    brand === "Pimalai Resort and Spa" ||
    brand === "Pimalai"
  ) {
    en = Object.assign(en, require("./PIMALAI/en.json"));
    fr = Object.assign(fr, require("./PIMALAI/fr.json"));
    ja = Object.assign(ja, require("./PIMALAI/ja.json"));
    th = Object.assign(th, require("./PIMALAI/th.json"));
    zh = Object.assign(zh, require("./PIMALAI/zh.json"));
    pt = Object.assign(pt, require("./PIMALAI/pt.json"));
    tr = Object.assign(tr, require("./PIMALAI/tr.json"));
    ru = Object.assign(ru, require("./PIMALAI/ru.json"));
    es = Object.assign(es, require("./PIMALAI/es.json"));
    de = Object.assign(de, require("./PIMALAI/de.json"));
    ko = Object.assign(ko, require("./PIMALAI/ko.json"));
    ar = Object.assign(ar, require("./PIMALAI/ar.json"));
    my = Object.assign(my, require("./PIMALAI/my.json"));
    it = Object.assign(it, require("./PIMALAI/it.json"));
    vi = Object.assign(vi, require("./PIMALAI/vi.json"));
    he = Object.assign(he, require("./PIMALAI/he.json"));
    nl = Object.assign(nl, require("./PIMALAI/nl.json"));

    en = Object.assign(en, require("./PIMALAI/tos-en.json"));
    fr = Object.assign(fr, require("./PIMALAI/tos-fr.json"));
    ja = Object.assign(ja, require("./PIMALAI/tos-ja.json"));
    th = Object.assign(th, require("./PIMALAI/tos-th.json"));
    zh = Object.assign(zh, require("./PIMALAI/tos-zh.json"));
    pt = Object.assign(pt, require("./PIMALAI/tos-pt.json"));
    tr = Object.assign(tr, require("./PIMALAI/tos-tr.json"));
    ru = Object.assign(ru, require("./PIMALAI/tos-ru.json"));
    es = Object.assign(es, require("./PIMALAI/tos-es.json"));
    de = Object.assign(de, require("./PIMALAI/tos-de.json"));
    ko = Object.assign(ko, require("./PIMALAI/tos-ko.json"));
    ar = Object.assign(ar, require("./PIMALAI/tos-ar.json"));
    my = Object.assign(my, require("./PIMALAI/tos-my.json"));
    it = Object.assign(it, require("./PIMALAI/tos-it.json"));
    vi = Object.assign(vi, require("./PIMALAI/tos-vi.json"));
    he = Object.assign(he, require("./PIMALAI/tos-he.json"));
    nl = Object.assign(nl, require("./PIMALAI/tos-nl.json"));
  } else if (
    brand === "The Standard Hotels" ||
    brand === "The Standard"
  ) {
    en = Object.assign(en, require("./STANDARD/en.json"));
    fr = Object.assign(fr, require("./STANDARD/fr.json"));
    ja = Object.assign(ja, require("./STANDARD/ja.json"));
    th = Object.assign(th, require("./STANDARD/th.json"));
    zh = Object.assign(zh, require("./STANDARD/zh.json"));
    pt = Object.assign(pt, require("./STANDARD/pt.json"));
    tr = Object.assign(tr, require("./STANDARD/tr.json"));
    ru = Object.assign(ru, require("./STANDARD/ru.json"));
    es = Object.assign(es, require("./STANDARD/es.json"));
    de = Object.assign(de, require("./STANDARD/de.json"));
    ko = Object.assign(ko, require("./STANDARD/ko.json"));
    ar = Object.assign(ar, require("./STANDARD/ar.json"));
    my = Object.assign(my, require("./STANDARD/my.json"));
    it = Object.assign(it, require("./STANDARD/it.json"));
    vi = Object.assign(vi, require("./STANDARD/vi.json"));
    he = Object.assign(he, require("./STANDARD/he.json"));
    nl = Object.assign(nl, require("./STANDARD/nl.json"));

    en = Object.assign(en, require("./STANDARD/tos-en.json"));
    fr = Object.assign(fr, require("./STANDARD/tos-fr.json"));
    ja = Object.assign(ja, require("./STANDARD/tos-ja.json"));
    th = Object.assign(th, require("./STANDARD/tos-th.json"));
    zh = Object.assign(zh, require("./STANDARD/tos-zh.json"));
    pt = Object.assign(pt, require("./STANDARD/tos-pt.json"));
    tr = Object.assign(tr, require("./STANDARD/tos-tr.json"));
    ru = Object.assign(ru, require("./STANDARD/tos-ru.json"));
    es = Object.assign(es, require("./STANDARD/tos-es.json"));
    de = Object.assign(de, require("./STANDARD/tos-de.json"));
    ko = Object.assign(ko, require("./STANDARD/tos-ko.json"));
    ar = Object.assign(ar, require("./STANDARD/tos-ar.json"));
    my = Object.assign(my, require("./STANDARD/tos-my.json"));
    it = Object.assign(it, require("./STANDARD/tos-it.json"));
    vi = Object.assign(vi, require("./STANDARD/tos-vi.json"));
    he = Object.assign(he, require("./STANDARD/tos-he.json"));
    nl = Object.assign(nl, require("./STANDARD/tos-nl.json"));
  } else if (brand === "ONYX Rewards" || brand === "ONYX") {
    en = Object.assign(en, require("./ONYX/en.json"));
    fr = Object.assign(fr, require("./ONYX/fr.json"));
    ja = Object.assign(ja, require("./ONYX/ja.json"));
    th = Object.assign(th, require("./ONYX/th.json"));
    zh = Object.assign(zh, require("./ONYX/zh.json"));
    pt = Object.assign(pt, require("./ONYX/pt.json"));
    tr = Object.assign(tr, require("./ONYX/tr.json"));
    ru = Object.assign(ru, require("./ONYX/ru.json"));
    es = Object.assign(es, require("./ONYX/es.json"));
    de = Object.assign(de, require("./ONYX/de.json"));
    ko = Object.assign(ko, require("./ONYX/ko.json"));
    ar = Object.assign(ar, require("./ONYX/ar.json"));
    my = Object.assign(my, require("./ONYX/my.json"));
    it = Object.assign(it, require("./ONYX/it.json"));
    vi = Object.assign(vi, require("./ONYX/vi.json"));
    he = Object.assign(he, require("./ONYX/he.json"));
    nl = Object.assign(nl, require("./ONYX/nl.json"));

    en = Object.assign(en, require("./ONYX/tos-en.json"));
    fr = Object.assign(fr, require("./ONYX/tos-fr.json"));
    ja = Object.assign(ja, require("./ONYX/tos-ja.json"));
    th = Object.assign(th, require("./ONYX/tos-th.json"));
    zh = Object.assign(zh, require("./ONYX/tos-zh.json"));
    pt = Object.assign(pt, require("./ONYX/tos-pt.json"));
    tr = Object.assign(tr, require("./ONYX/tos-tr.json"));
    ru = Object.assign(ru, require("./ONYX/tos-ru.json"));
    es = Object.assign(es, require("./ONYX/tos-es.json"));
    de = Object.assign(de, require("./ONYX/tos-de.json"));
    ko = Object.assign(ko, require("./ONYX/tos-ko.json"));
    ar = Object.assign(ar, require("./ONYX/tos-ar.json"));
    my = Object.assign(my, require("./ONYX/tos-my.json"));
    it = Object.assign(it, require("./ONYX/tos-it.json"));
    vi = Object.assign(vi, require("./ONYX/tos-vi.json"));
    he = Object.assign(he, require("./ONYX/tos-he.json"));
    nl = Object.assign(he, require("./ONYX/tos-he.json"));
  } else if (
    brand === "InterContinental" ||
    brand === "InterContinental Enterprise" ||
    brand === "Intercontinental Hotels & Resorts"
  ) {
    en = Object.assign(en, require("./INTERCONTINENTAL/en.json"));
    fr = Object.assign(fr, require("./INTERCONTINENTAL/fr.json"));
    ja = Object.assign(ja, require("./INTERCONTINENTAL/ja.json"));
    th = Object.assign(th, require("./INTERCONTINENTAL/th.json"));
    zh = Object.assign(zh, require("./INTERCONTINENTAL/zh.json"));
    pt = Object.assign(pt, require("./INTERCONTINENTAL/pt.json"));
    tr = Object.assign(tr, require("./INTERCONTINENTAL/tr.json"));
    ru = Object.assign(ru, require("./INTERCONTINENTAL/ru.json"));
    es = Object.assign(es, require("./INTERCONTINENTAL/es.json"));
    de = Object.assign(de, require("./INTERCONTINENTAL/de.json"));
    ko = Object.assign(ko, require("./INTERCONTINENTAL/ko.json"));
    ar = Object.assign(ar, require("./INTERCONTINENTAL/ar.json"));
    my = Object.assign(my, require("./INTERCONTINENTAL/my.json"));
    it = Object.assign(it, require("./INTERCONTINENTAL/it.json"));
    vi = Object.assign(vi, require("./INTERCONTINENTAL/vi.json"));
    he = Object.assign(he, require("./INTERCONTINENTAL/he.json"));
    nl = Object.assign(nl, require("./INTERCONTINENTAL/nl.json"));

    en = Object.assign(en, require("./INTERCONTINENTAL/tos-en.json"));
    fr = Object.assign(fr, require("./INTERCONTINENTAL/tos-fr.json"));
    ja = Object.assign(ja, require("./INTERCONTINENTAL/tos-ja.json"));
    th = Object.assign(th, require("./INTERCONTINENTAL/tos-th.json"));
    zh = Object.assign(zh, require("./INTERCONTINENTAL/tos-zh.json"));
    pt = Object.assign(pt, require("./INTERCONTINENTAL/tos-pt.json"));
    tr = Object.assign(tr, require("./INTERCONTINENTAL/tos-tr.json"));
    ru = Object.assign(ru, require("./INTERCONTINENTAL/tos-ru.json"));
    es = Object.assign(es, require("./INTERCONTINENTAL/tos-es.json"));
    de = Object.assign(de, require("./INTERCONTINENTAL/tos-de.json"));
    ko = Object.assign(ko, require("./INTERCONTINENTAL/tos-ko.json"));
    ar = Object.assign(ar, require("./INTERCONTINENTAL/tos-ar.json"));
    my = Object.assign(my, require("./INTERCONTINENTAL/tos-my.json"));
    it = Object.assign(it, require("./INTERCONTINENTAL/tos-it.json"));
    vi = Object.assign(vi, require("./INTERCONTINENTAL/tos-vi.json"));
    he = Object.assign(he, require("./INTERCONTINENTAL/tos-he.json"));
    nl = Object.assign(nl, require("./INTERCONTINENTAL/tos-nl.json"));
  } else if (
    brand === "The George" ||
    brand === "The George Tel Aviv"
  ) {
    en = Object.assign(en, require("./GEORGE/en.json"));
    fr = Object.assign(fr, require("./GEORGE/fr.json"));
    ja = Object.assign(ja, require("./GEORGE/ja.json"));
    th = Object.assign(th, require("./GEORGE/th.json"));
    zh = Object.assign(zh, require("./GEORGE/zh.json"));
    pt = Object.assign(pt, require("./GEORGE/pt.json"));
    tr = Object.assign(tr, require("./GEORGE/tr.json"));
    ru = Object.assign(ru, require("./GEORGE/ru.json"));
    es = Object.assign(es, require("./GEORGE/es.json"));
    de = Object.assign(de, require("./GEORGE/de.json"));
    ko = Object.assign(ko, require("./GEORGE/ko.json"));
    ar = Object.assign(ar, require("./GEORGE/ar.json"));
    my = Object.assign(my, require("./GEORGE/my.json"));
    it = Object.assign(it, require("./GEORGE/it.json"));
    vi = Object.assign(vi, require("./GEORGE/vi.json"));
    he = Object.assign(he, require("./GEORGE/he.json"));
    nl = Object.assign(nl, require("./GEORGE/nl.json"));

    en = Object.assign(en, require("./GEORGE/tos-en.json"));
    fr = Object.assign(fr, require("./GEORGE/tos-fr.json"));
    ja = Object.assign(ja, require("./GEORGE/tos-ja.json"));
    th = Object.assign(th, require("./GEORGE/tos-th.json"));
    zh = Object.assign(zh, require("./GEORGE/tos-zh.json"));
    pt = Object.assign(pt, require("./GEORGE/tos-pt.json"));
    tr = Object.assign(tr, require("./GEORGE/tos-tr.json"));
    ru = Object.assign(ru, require("./GEORGE/tos-ru.json"));
    es = Object.assign(es, require("./GEORGE/tos-es.json"));
    de = Object.assign(de, require("./GEORGE/tos-de.json"));
    ko = Object.assign(ko, require("./GEORGE/tos-ko.json"));
    ar = Object.assign(ar, require("./GEORGE/tos-ar.json"));
    my = Object.assign(my, require("./GEORGE/tos-my.json"));
    it = Object.assign(it, require("./GEORGE/tos-it.json"));
    vi = Object.assign(vi, require("./GEORGE/tos-vi.json"));
    he = Object.assign(he, require("./GEORGE/tos-he.json"));
    nl = Object.assign(nl, require("./GEORGE/tos-nl.json"));
  } else if (
    brand === "Hotel Barriere" ||
    brand === "Barriere"
  ) {
    en = Object.assign(en, require("./BARRIERE/en.json"));
    fr = Object.assign(fr, require("./BARRIERE/fr.json"));
    ja = Object.assign(ja, require("./BARRIERE/ja.json"));
    th = Object.assign(th, require("./BARRIERE/th.json"));
    zh = Object.assign(zh, require("./BARRIERE/zh.json"));
    pt = Object.assign(pt, require("./BARRIERE/pt.json"));
    tr = Object.assign(tr, require("./BARRIERE/tr.json"));
    ru = Object.assign(ru, require("./BARRIERE/ru.json"));
    es = Object.assign(es, require("./BARRIERE/es.json"));
    de = Object.assign(de, require("./BARRIERE/de.json"));
    ko = Object.assign(ko, require("./BARRIERE/ko.json"));
    ar = Object.assign(ar, require("./BARRIERE/ar.json"));
    my = Object.assign(my, require("./BARRIERE/my.json"));
    it = Object.assign(it, require("./BARRIERE/it.json"));
    vi = Object.assign(vi, require("./BARRIERE/vi.json"));
    he = Object.assign(he, require("./BARRIERE/he.json"));
    nl = Object.assign(nl, require("./BARRIERE/nl.json"));

    en = Object.assign(en, require("./BARRIERE/tos-en.json"));
    fr = Object.assign(fr, require("./BARRIERE/tos-fr.json"));
    ja = Object.assign(ja, require("./BARRIERE/tos-ja.json"));
    th = Object.assign(th, require("./BARRIERE/tos-th.json"));
    zh = Object.assign(zh, require("./BARRIERE/tos-zh.json"));
    pt = Object.assign(pt, require("./BARRIERE/tos-pt.json"));
    tr = Object.assign(tr, require("./BARRIERE/tos-tr.json"));
    ru = Object.assign(ru, require("./BARRIERE/tos-ru.json"));
    es = Object.assign(es, require("./BARRIERE/tos-es.json"));
    de = Object.assign(de, require("./BARRIERE/tos-de.json"));
    ko = Object.assign(ko, require("./BARRIERE/tos-ko.json"));
    ar = Object.assign(ar, require("./BARRIERE/tos-ar.json"));
    my = Object.assign(my, require("./BARRIERE/tos-my.json"));
    it = Object.assign(it, require("./BARRIERE/tos-it.json"));
    vi = Object.assign(vi, require("./BARRIERE/tos-vi.json"));
    he = Object.assign(he, require("./BARRIERE/tos-he.json"));
    nl = Object.assign(nl, require("./BARRIERE/tos-nl.json"));
  } else if (
    brand === "Evermore Resort" ||
    brand === "Evermore Resort Orlando" ||
    brand === "Evermore"
  ) {
    en = Object.assign(en, require("./EVERMORE/en.json"));
    fr = Object.assign(fr, require("./EVERMORE/fr.json"));
    ja = Object.assign(ja, require("./EVERMORE/ja.json"));
    th = Object.assign(th, require("./EVERMORE/th.json"));
    zh = Object.assign(zh, require("./EVERMORE/zh.json"));
    pt = Object.assign(pt, require("./EVERMORE/pt.json"));
    tr = Object.assign(tr, require("./EVERMORE/tr.json"));
    ru = Object.assign(ru, require("./EVERMORE/ru.json"));
    es = Object.assign(es, require("./EVERMORE/es.json"));
    de = Object.assign(de, require("./EVERMORE/de.json"));
    ko = Object.assign(ko, require("./EVERMORE/ko.json"));
    ar = Object.assign(ar, require("./EVERMORE/ar.json"));
    my = Object.assign(my, require("./EVERMORE/my.json"));
    it = Object.assign(it, require("./EVERMORE/it.json"));
    vi = Object.assign(vi, require("./EVERMORE/vi.json"));
    he = Object.assign(he, require("./EVERMORE/he.json"));
    nl = Object.assign(nl, require("./EVERMORE/nl.json"));

    en = Object.assign(en, require("./EVERMORE/tos-en.json"));
    fr = Object.assign(fr, require("./EVERMORE/tos-fr.json"));
    ja = Object.assign(ja, require("./EVERMORE/tos-ja.json"));
    th = Object.assign(th, require("./EVERMORE/tos-th.json"));
    zh = Object.assign(zh, require("./EVERMORE/tos-zh.json"));
    pt = Object.assign(pt, require("./EVERMORE/tos-pt.json"));
    tr = Object.assign(tr, require("./EVERMORE/tos-tr.json"));
    ru = Object.assign(ru, require("./EVERMORE/tos-ru.json"));
    es = Object.assign(es, require("./EVERMORE/tos-es.json"));
    de = Object.assign(de, require("./EVERMORE/tos-de.json"));
    ko = Object.assign(ko, require("./EVERMORE/tos-ko.json"));
    ar = Object.assign(ar, require("./EVERMORE/tos-ar.json"));
    my = Object.assign(my, require("./EVERMORE/tos-my.json"));
    it = Object.assign(it, require("./EVERMORE/tos-it.json"));
    vi = Object.assign(vi, require("./EVERMORE/tos-vi.json"));
    he = Object.assign(he, require("./EVERMORE/tos-he.json"));
    nl = Object.assign(nl, require("./EVERMORE/tos-nl.json"));
  } else if (brand === "NH Hotels") {
    en = Object.assign(en, require("./NH/en.json"));
    fr = Object.assign(fr, require("./NH/fr.json"));
    ja = Object.assign(ja, require("./NH/ja.json"));
    th = Object.assign(th, require("./NH/th.json"));
    zh = Object.assign(zh, require("./NH/zh.json"));
    pt = Object.assign(pt, require("./NH/pt.json"));
    tr = Object.assign(tr, require("./NH/tr.json"));
    ru = Object.assign(ru, require("./NH/ru.json"));
    es = Object.assign(es, require("./NH/es.json"));
    de = Object.assign(de, require("./NH/de.json"));
    ko = Object.assign(ko, require("./NH/ko.json"));
    ar = Object.assign(ar, require("./NH/ar.json"));
    my = Object.assign(my, require("./NH/my.json"));
    it = Object.assign(it, require("./NH/it.json"));
    vi = Object.assign(vi, require("./NH/vi.json"));
    he = Object.assign(he, require("./NH/he.json"));
    nl = Object.assign(nl, require("./NH/nl.json"));

    en = Object.assign(en, require("./NH/tos-en.json"));
    fr = Object.assign(fr, require("./NH/tos-fr.json"));
    ja = Object.assign(ja, require("./NH/tos-ja.json"));
    th = Object.assign(th, require("./NH/tos-th.json"));
    zh = Object.assign(zh, require("./NH/tos-zh.json"));
    pt = Object.assign(pt, require("./NH/tos-pt.json"));
    tr = Object.assign(tr, require("./NH/tos-tr.json"));
    ru = Object.assign(ru, require("./NH/tos-ru.json"));
    es = Object.assign(es, require("./NH/tos-es.json"));
    de = Object.assign(de, require("./NH/tos-de.json"));
    ko = Object.assign(ko, require("./NH/tos-ko.json"));
    ar = Object.assign(ar, require("./NH/tos-ar.json"));
    my = Object.assign(my, require("./NH/tos-my.json"));
    it = Object.assign(it, require("./NH/tos-it.json"));
    vi = Object.assign(vi, require("./NH/tos-vi.json"));
    he = Object.assign(he, require("./NH/tos-he.json"));
    nl = Object.assign(nl, require("./NH/tos-nl.json"));
  } else if (brand === "Ad Lib Hotel Group") {
    en = Object.assign(en, require("./000-000-0930/en.json"));
    fr = Object.assign(fr, require("./000-000-0930/fr.json"));
    ja = Object.assign(ja, require("./000-000-0930/ja.json"));
    th = Object.assign(th, require("./000-000-0930/th.json"));
    zh = Object.assign(zh, require("./000-000-0930/zh.json"));
    pt = Object.assign(pt, require("./000-000-0930/pt.json"));
    tr = Object.assign(tr, require("./000-000-0930/tr.json"));
    ru = Object.assign(ru, require("./000-000-0930/ru.json"));
    es = Object.assign(es, require("./000-000-0930/es.json"));
    de = Object.assign(de, require("./000-000-0930/de.json"));
    ko = Object.assign(ko, require("./000-000-0930/ko.json"));
    ar = Object.assign(ar, require("./000-000-0930/ar.json"));
    my = Object.assign(my, require("./000-000-0930/my.json"));
    it = Object.assign(it, require("./000-000-0930/it.json"));
    vi = Object.assign(vi, require("./000-000-0930/vi.json"));
    he = Object.assign(he, require("./000-000-0930/he.json"));
    nl = Object.assign(nl, require("./000-000-0930/nl.json"));

    en = Object.assign(en, require("./000-000-0930/tos-en.json"));
    fr = Object.assign(fr, require("./000-000-0930/tos-fr.json"));
    ja = Object.assign(ja, require("./000-000-0930/tos-ja.json"));
    th = Object.assign(th, require("./000-000-0930/tos-th.json"));
    zh = Object.assign(zh, require("./000-000-0930/tos-zh.json"));
    pt = Object.assign(pt, require("./000-000-0930/tos-pt.json"));
    tr = Object.assign(tr, require("./000-000-0930/tos-tr.json"));
    ru = Object.assign(ru, require("./000-000-0930/tos-ru.json"));
    es = Object.assign(es, require("./000-000-0930/tos-es.json"));
    de = Object.assign(de, require("./000-000-0930/tos-de.json"));
    ko = Object.assign(ko, require("./000-000-0930/tos-ko.json"));
    ar = Object.assign(ar, require("./000-000-0930/tos-ar.json"));
    my = Object.assign(my, require("./000-000-0930/tos-my.json"));
    it = Object.assign(it, require("./000-000-0930/tos-it.json"));
    vi = Object.assign(vi, require("./000-000-0930/tos-vi.json"));
    he = Object.assign(he, require("./000-000-0930/tos-he.json"));
    nl = Object.assign(nl, require("./000-000-0930/tos-nl.json"));
  } else if (brand === "NEXT Hotels") {
    en = Object.assign(en, require("./NEXT/en.json"));
    fr = Object.assign(fr, require("./NEXT/fr.json"));
    ja = Object.assign(ja, require("./NEXT/ja.json"));
    th = Object.assign(th, require("./NEXT/th.json"));
    zh = Object.assign(zh, require("./NEXT/zh.json"));
    pt = Object.assign(pt, require("./NEXT/pt.json"));
    tr = Object.assign(tr, require("./NEXT/tr.json"));
    ru = Object.assign(ru, require("./NEXT/ru.json"));
    es = Object.assign(es, require("./NEXT/es.json"));
    de = Object.assign(de, require("./NEXT/de.json"));
    ko = Object.assign(ko, require("./NEXT/ko.json"));
    ar = Object.assign(ar, require("./NEXT/ar.json"));
    my = Object.assign(my, require("./NEXT/my.json"));
    it = Object.assign(it, require("./NEXT/it.json"));
    vi = Object.assign(vi, require("./NEXT/vi.json"));
    he = Object.assign(he, require("./NEXT/he.json"));
    nl = Object.assign(nl, require("./NEXT/nl.json"));

    en = Object.assign(en, require("./NEXT/tos-en.json"));
    fr = Object.assign(fr, require("./NEXT/tos-fr.json"));
    ja = Object.assign(ja, require("./NEXT/tos-ja.json"));
    th = Object.assign(th, require("./NEXT/tos-th.json"));
    zh = Object.assign(zh, require("./NEXT/tos-zh.json"));
    pt = Object.assign(pt, require("./NEXT/tos-pt.json"));
    tr = Object.assign(tr, require("./NEXT/tos-tr.json"));
    ru = Object.assign(ru, require("./NEXT/tos-ru.json"));
    es = Object.assign(es, require("./NEXT/tos-es.json"));
    de = Object.assign(de, require("./NEXT/tos-de.json"));
    ko = Object.assign(ko, require("./NEXT/tos-ko.json"));
    ar = Object.assign(ar, require("./NEXT/tos-ar.json"));
    my = Object.assign(my, require("./NEXT/tos-my.json"));
    it = Object.assign(it, require("./NEXT/tos-it.json"));
    vi = Object.assign(vi, require("./NEXT/tos-vi.json"));
    he = Object.assign(he, require("./NEXT/tos-he.json"));
    nl = Object.assign(nl, require("./NEXT/tos-nl.json"));
  } else if (brand === "Oaks Hotels, Resorts & Suites") {
    en = Object.assign(en, require("./000-000-0929/en.json"));
    fr = Object.assign(fr, require("./000-000-0929/fr.json"));
    ja = Object.assign(ja, require("./000-000-0929/ja.json"));
    th = Object.assign(th, require("./000-000-0929/th.json"));
    zh = Object.assign(zh, require("./000-000-0929/zh.json"));
    pt = Object.assign(pt, require("./000-000-0929/pt.json"));
    tr = Object.assign(tr, require("./000-000-0929/tr.json"));
    ru = Object.assign(ru, require("./000-000-0929/ru.json"));
    es = Object.assign(es, require("./000-000-0929/es.json"));
    de = Object.assign(de, require("./000-000-0929/de.json"));
    ko = Object.assign(ko, require("./000-000-0929/ko.json"));
    ar = Object.assign(ar, require("./000-000-0929/ar.json"));
    my = Object.assign(my, require("./000-000-0929/my.json"));
    it = Object.assign(it, require("./000-000-0929/it.json"));
    vi = Object.assign(vi, require("./000-000-0929/vi.json"));
    he = Object.assign(he, require("./000-000-0929/he.json"));
    nl = Object.assign(nl, require("./000-000-0929/nl.json"));

    en = Object.assign(en, require("./000-000-0929/tos-en.json"));
    fr = Object.assign(fr, require("./000-000-0929/tos-fr.json"));
    ja = Object.assign(ja, require("./000-000-0929/tos-ja.json"));
    th = Object.assign(th, require("./000-000-0929/tos-th.json"));
    zh = Object.assign(zh, require("./000-000-0929/tos-zh.json"));
    pt = Object.assign(pt, require("./000-000-0929/tos-pt.json"));
    tr = Object.assign(tr, require("./000-000-0929/tos-tr.json"));
    ru = Object.assign(ru, require("./000-000-0929/tos-ru.json"));
    es = Object.assign(es, require("./000-000-0929/tos-es.json"));
    de = Object.assign(de, require("./000-000-0929/tos-de.json"));
    ko = Object.assign(ko, require("./000-000-0929/tos-ko.json"));
    ar = Object.assign(ar, require("./000-000-0929/tos-ar.json"));
    my = Object.assign(my, require("./000-000-0929/tos-my.json"));
    it = Object.assign(it, require("./000-000-0929/tos-it.json"));
    vi = Object.assign(vi, require("./000-000-0929/tos-vi.json"));
    he = Object.assign(he, require("./000-000-0929/tos-he.json"));
    nl = Object.assign(nl, require("./000-000-0929/tos-nl.json"));
  } else if (brand === "CIRQ Brand") {
    en = Object.assign(en, require("./CIRQ/en.json"));
    fr = Object.assign(fr, require("./CIRQ/fr.json"));
    ja = Object.assign(ja, require("./CIRQ/ja.json"));
    th = Object.assign(th, require("./CIRQ/th.json"));
    zh = Object.assign(zh, require("./CIRQ/zh.json"));
    pt = Object.assign(pt, require("./CIRQ/pt.json"));
    tr = Object.assign(tr, require("./CIRQ/tr.json"));
    ru = Object.assign(ru, require("./CIRQ/ru.json"));
    es = Object.assign(es, require("./CIRQ/es.json"));
    de = Object.assign(de, require("./CIRQ/de.json"));
    ko = Object.assign(ko, require("./CIRQ/ko.json"));
    ar = Object.assign(ar, require("./CIRQ/ar.json"));
    my = Object.assign(my, require("./CIRQ/my.json"));
    it = Object.assign(it, require("./CIRQ/it.json"));
    vi = Object.assign(vi, require("./CIRQ/vi.json"));
    he = Object.assign(he, require("./CIRQ/he.json"));
    nl = Object.assign(nl, require("./CIRQ/nl.json"));

    en = Object.assign(en, require("./CIRQ/tos-en.json"));
    fr = Object.assign(fr, require("./CIRQ/tos-fr.json"));
    ja = Object.assign(ja, require("./CIRQ/tos-ja.json"));
    th = Object.assign(th, require("./CIRQ/tos-th.json"));
    zh = Object.assign(zh, require("./CIRQ/tos-zh.json"));
    pt = Object.assign(pt, require("./CIRQ/tos-pt.json"));
    tr = Object.assign(tr, require("./CIRQ/tos-tr.json"));
    ru = Object.assign(ru, require("./CIRQ/tos-ru.json"));
    es = Object.assign(es, require("./CIRQ/tos-es.json"));
    de = Object.assign(de, require("./CIRQ/tos-de.json"));
    ko = Object.assign(ko, require("./CIRQ/tos-ko.json"));
    ar = Object.assign(ar, require("./CIRQ/tos-ar.json"));
    my = Object.assign(my, require("./CIRQ/tos-my.json"));
    it = Object.assign(it, require("./CIRQ/tos-it.json"));
    vi = Object.assign(vi, require("./CIRQ/tos-vi.json"));
    he = Object.assign(he, require("./CIRQ/tos-he.json"));
    nl = Object.assign(nl, require("./CIRQ/tos-nl.json"));
  } else if (
    brand === "Rydges Hotels & Resorts" ||
    brand === "Rydges Hotels"
  ) {
    en = Object.assign(en, require("./000-000-0701/en.json"));
    fr = Object.assign(fr, require("./000-000-0701/fr.json"));
    ja = Object.assign(ja, require("./000-000-0701/ja.json"));
    th = Object.assign(th, require("./000-000-0701/th.json"));
    zh = Object.assign(zh, require("./000-000-0701/zh.json"));
    pt = Object.assign(pt, require("./000-000-0701/pt.json"));
    tr = Object.assign(tr, require("./000-000-0701/tr.json"));
    ru = Object.assign(ru, require("./000-000-0701/ru.json"));
    es = Object.assign(es, require("./000-000-0701/es.json"));
    de = Object.assign(de, require("./000-000-0701/de.json"));
    ko = Object.assign(ko, require("./000-000-0701/ko.json"));
    ar = Object.assign(ar, require("./000-000-0701/ar.json"));
    my = Object.assign(my, require("./000-000-0701/my.json"));
    it = Object.assign(it, require("./000-000-0701/it.json"));
    vi = Object.assign(vi, require("./000-000-0701/vi.json"));
    he = Object.assign(he, require("./000-000-0701/he.json"));
    nl = Object.assign(nl, require("./000-000-0701/nl.json"));

    en = Object.assign(en, require("./000-000-0701/tos-en.json"));
    fr = Object.assign(fr, require("./000-000-0701/tos-fr.json"));
    ja = Object.assign(ja, require("./000-000-0701/tos-ja.json"));
    th = Object.assign(th, require("./000-000-0701/tos-th.json"));
    zh = Object.assign(zh, require("./000-000-0701/tos-zh.json"));
    pt = Object.assign(pt, require("./000-000-0701/tos-pt.json"));
    tr = Object.assign(tr, require("./000-000-0701/tos-tr.json"));
    ru = Object.assign(ru, require("./000-000-0701/tos-ru.json"));
    es = Object.assign(es, require("./000-000-0701/tos-es.json"));
    de = Object.assign(de, require("./000-000-0701/tos-de.json"));
    ko = Object.assign(ko, require("./000-000-0701/tos-ko.json"));
    ar = Object.assign(ar, require("./000-000-0701/tos-ar.json"));
    my = Object.assign(my, require("./000-000-0701/tos-my.json"));
    it = Object.assign(it, require("./000-000-0701/tos-it.json"));
    vi = Object.assign(vi, require("./000-000-0701/tos-vi.json"));
    he = Object.assign(he, require("./000-000-0701/tos-he.json"));
    nl = Object.assign(nl, require("./000-000-0701/tos-nl.json"));
  } else if (brand === "Oaga Resort" || brand === "Oaga") {
    en = Object.assign(en, require("./OAGA/en.json"));
    fr = Object.assign(fr, require("./OAGA/fr.json"));
    ja = Object.assign(ja, require("./OAGA/ja.json"));
    th = Object.assign(th, require("./OAGA/th.json"));
    zh = Object.assign(zh, require("./OAGA/zh.json"));
    pt = Object.assign(pt, require("./OAGA/pt.json"));
    tr = Object.assign(tr, require("./OAGA/tr.json"));
    ru = Object.assign(ru, require("./OAGA/ru.json"));
    es = Object.assign(es, require("./OAGA/es.json"));
    de = Object.assign(de, require("./OAGA/de.json"));
    ko = Object.assign(ko, require("./OAGA/ko.json"));
    ar = Object.assign(ar, require("./OAGA/ar.json"));
    my = Object.assign(my, require("./OAGA/my.json"));
    it = Object.assign(it, require("./OAGA/it.json"));
    vi = Object.assign(vi, require("./OAGA/vi.json"));
    he = Object.assign(he, require("./OAGA/he.json"));
    nl = Object.assign(nl, require("./OAGA/nl.json"));

    en = Object.assign(en, require("./OAGA/tos-en.json"));
    fr = Object.assign(fr, require("./OAGA/tos-fr.json"));
    ja = Object.assign(ja, require("./OAGA/tos-ja.json"));
    th = Object.assign(th, require("./OAGA/tos-th.json"));
    zh = Object.assign(zh, require("./OAGA/tos-zh.json"));
    pt = Object.assign(pt, require("./OAGA/tos-pt.json"));
    tr = Object.assign(tr, require("./OAGA/tos-tr.json"));
    ru = Object.assign(ru, require("./OAGA/tos-ru.json"));
    es = Object.assign(es, require("./OAGA/tos-es.json"));
    de = Object.assign(de, require("./OAGA/tos-de.json"));
    ko = Object.assign(ko, require("./OAGA/tos-ko.json"));
    ar = Object.assign(ar, require("./OAGA/tos-ar.json"));
    my = Object.assign(my, require("./OAGA/tos-my.json"));
    it = Object.assign(it, require("./OAGA/tos-it.json"));
    vi = Object.assign(vi, require("./OAGA/tos-vi.json"));
    he = Object.assign(he, require("./OAGA/tos-he.json"));
    nl = Object.assign(nl, require("./OAGA/tos-nl.json"));
  } else if (brand === "Holiday Inn") {
    en = Object.assign(en, require("./HOLIDAY_INN/en.json"));
    fr = Object.assign(fr, require("./HOLIDAY_INN/fr.json"));
    ja = Object.assign(ja, require("./HOLIDAY_INN/ja.json"));
    th = Object.assign(th, require("./HOLIDAY_INN/th.json"));
    zh = Object.assign(zh, require("./HOLIDAY_INN/zh.json"));
    pt = Object.assign(pt, require("./HOLIDAY_INN/pt.json"));
    tr = Object.assign(tr, require("./HOLIDAY_INN/tr.json"));
    ru = Object.assign(ru, require("./HOLIDAY_INN/ru.json"));
    es = Object.assign(es, require("./HOLIDAY_INN/es.json"));
    de = Object.assign(de, require("./HOLIDAY_INN/de.json"));
    ko = Object.assign(ko, require("./HOLIDAY_INN/ko.json"));
    ar = Object.assign(ar, require("./HOLIDAY_INN/ar.json"));
    my = Object.assign(my, require("./HOLIDAY_INN/my.json"));
    it = Object.assign(it, require("./HOLIDAY_INN/it.json"));
    vi = Object.assign(vi, require("./HOLIDAY_INN/vi.json"));
    he = Object.assign(he, require("./HOLIDAY_INN/he.json"));
    nl = Object.assign(nl, require("./HOLIDAY_INN/nl.json"));

    en = Object.assign(en, require("./HOLIDAY_INN/tos-en.json"));
    fr = Object.assign(fr, require("./HOLIDAY_INN/tos-fr.json"));
    ja = Object.assign(ja, require("./HOLIDAY_INN/tos-ja.json"));
    th = Object.assign(th, require("./HOLIDAY_INN/tos-th.json"));
    zh = Object.assign(zh, require("./HOLIDAY_INN/tos-zh.json"));
    pt = Object.assign(pt, require("./HOLIDAY_INN/tos-pt.json"));
    tr = Object.assign(tr, require("./HOLIDAY_INN/tos-tr.json"));
    ru = Object.assign(ru, require("./HOLIDAY_INN/tos-ru.json"));
    es = Object.assign(es, require("./HOLIDAY_INN/tos-es.json"));
    de = Object.assign(de, require("./HOLIDAY_INN/tos-de.json"));
    ko = Object.assign(ko, require("./HOLIDAY_INN/tos-ko.json"));
    ar = Object.assign(ar, require("./HOLIDAY_INN/tos-ar.json"));
    my = Object.assign(my, require("./HOLIDAY_INN/tos-my.json"));
    it = Object.assign(it, require("./HOLIDAY_INN/tos-it.json"));
    vi = Object.assign(vi, require("./HOLIDAY_INN/tos-vi.json"));
    he = Object.assign(he, require("./HOLIDAY_INN/tos-he.json"));
    nl = Object.assign(nl, require("./HOLIDAY_INN/tos-nl.json"));
  } else if (brand === "Fairmont") {
    en = Object.assign(en, require("./000-000-0928/en.json"));
    fr = Object.assign(fr, require("./000-000-0928/fr.json"));
    ja = Object.assign(ja, require("./000-000-0928/ja.json"));
    th = Object.assign(th, require("./000-000-0928/th.json"));
    zh = Object.assign(zh, require("./000-000-0928/zh.json"));
    pt = Object.assign(pt, require("./000-000-0928/pt.json"));
    tr = Object.assign(tr, require("./000-000-0928/tr.json"));
    ru = Object.assign(ru, require("./000-000-0928/ru.json"));
    es = Object.assign(es, require("./000-000-0928/es.json"));
    de = Object.assign(de, require("./000-000-0928/de.json"));
    ko = Object.assign(ko, require("./000-000-0928/ko.json"));
    ar = Object.assign(ar, require("./000-000-0928/ar.json"));
    my = Object.assign(my, require("./000-000-0928/my.json"));
    it = Object.assign(it, require("./000-000-0928/it.json"));
    vi = Object.assign(vi, require("./000-000-0928/vi.json"));
    he = Object.assign(he, require("./000-000-0928/he.json"));
    nl = Object.assign(nl, require("./000-000-0928/nl.json"));

    en = Object.assign(en, require("./000-000-0928/tos-en.json"));
    fr = Object.assign(fr, require("./000-000-0928/tos-fr.json"));
    ja = Object.assign(ja, require("./000-000-0928/tos-ja.json"));
    th = Object.assign(th, require("./000-000-0928/tos-th.json"));
    zh = Object.assign(zh, require("./000-000-0928/tos-zh.json"));
    pt = Object.assign(pt, require("./000-000-0928/tos-pt.json"));
    tr = Object.assign(tr, require("./000-000-0928/tos-tr.json"));
    ru = Object.assign(ru, require("./000-000-0928/tos-ru.json"));
    es = Object.assign(es, require("./000-000-0928/tos-es.json"));
    de = Object.assign(de, require("./000-000-0928/tos-de.json"));
    ko = Object.assign(ko, require("./000-000-0928/tos-ko.json"));
    ar = Object.assign(ar, require("./000-000-0928/tos-ar.json"));
    my = Object.assign(my, require("./000-000-0928/tos-my.json"));
    it = Object.assign(it, require("./000-000-0928/tos-it.json"));
    vi = Object.assign(vi, require("./000-000-0928/tos-vi.json"));
    he = Object.assign(he, require("./000-000-0928/tos-he.json"));
    nl = Object.assign(nl, require("./000-000-0928/tos-nl.json"));
  } else if (
    brand === "Intercontinental Sing{apore" ||
    brand === "ICONnect SG"
  ) {
    en = Object.assign(en, require("./INTERCONTINENTAL_SINGAPORE/en.json"));
    fr = Object.assign(fr, require("./INTERCONTINENTAL_SINGAPORE/fr.json"));
    ja = Object.assign(ja, require("./INTERCONTINENTAL_SINGAPORE/ja.json"));
    th = Object.assign(th, require("./INTERCONTINENTAL_SINGAPORE/th.json"));
    zh = Object.assign(zh, require("./INTERCONTINENTAL_SINGAPORE/zh.json"));
    pt = Object.assign(pt, require("./INTERCONTINENTAL_SINGAPORE/pt.json"));
    tr = Object.assign(tr, require("./INTERCONTINENTAL_SINGAPORE/tr.json"));
    ru = Object.assign(ru, require("./INTERCONTINENTAL_SINGAPORE/ru.json"));
    es = Object.assign(es, require("./INTERCONTINENTAL_SINGAPORE/es.json"));
    de = Object.assign(de, require("./INTERCONTINENTAL_SINGAPORE/de.json"));
    ko = Object.assign(ko, require("./INTERCONTINENTAL_SINGAPORE/ko.json"));
    ar = Object.assign(ar, require("./INTERCONTINENTAL_SINGAPORE/ar.json"));
    my = Object.assign(my, require("./INTERCONTINENTAL_SINGAPORE/my.json"));
    it = Object.assign(it, require("./INTERCONTINENTAL_SINGAPORE/it.json"));
    vi = Object.assign(vi, require("./INTERCONTINENTAL_SINGAPORE/vi.json"));
    he = Object.assign(he, require("./INTERCONTINENTAL_SINGAPORE/he.json"));
    nl = Object.assign(nl, require("./INTERCONTINENTAL_SINGAPORE/nl.json"));

    en = Object.assign(en, require("./INTERCONTINENTAL_SINGAPORE/tos-en.json"));
    fr = Object.assign(fr, require("./INTERCONTINENTAL_SINGAPORE/tos-fr.json"));
    ja = Object.assign(ja, require("./INTERCONTINENTAL_SINGAPORE/tos-ja.json"));
    th = Object.assign(th, require("./INTERCONTINENTAL_SINGAPORE/tos-th.json"));
    zh = Object.assign(zh, require("./INTERCONTINENTAL_SINGAPORE/tos-zh.json"));
    pt = Object.assign(pt, require("./INTERCONTINENTAL_SINGAPORE/tos-pt.json"));
    tr = Object.assign(tr, require("./INTERCONTINENTAL_SINGAPORE/tos-tr.json"));
    ru = Object.assign(ru, require("./INTERCONTINENTAL_SINGAPORE/tos-ru.json"));
    es = Object.assign(es, require("./INTERCONTINENTAL_SINGAPORE/tos-es.json"));
    de = Object.assign(de, require("./INTERCONTINENTAL_SINGAPORE/tos-de.json"));
    ko = Object.assign(ko, require("./INTERCONTINENTAL_SINGAPORE/tos-ko.json"));
    ar = Object.assign(ar, require("./INTERCONTINENTAL_SINGAPORE/tos-ar.json"));
    my = Object.assign(my, require("./INTERCONTINENTAL_SINGAPORE/tos-my.json"));
    it = Object.assign(it, require("./INTERCONTINENTAL_SINGAPORE/tos-it.json"));
    vi = Object.assign(vi, require("./INTERCONTINENTAL_SINGAPORE/tos-vi.json"));
    he = Object.assign(he, require("./INTERCONTINENTAL_SINGAPORE/tos-he.json"));
    nl = Object.assign(nl, require("./INTERCONTINENTAL_SINGAPORE/tos-nl.json"));
  } else if (brand === "Aman") {
    en = Object.assign(en, require("./000-000-0334/en.json"));
    fr = Object.assign(fr, require("./000-000-0334/fr.json"));
    ja = Object.assign(ja, require("./000-000-0334/ja.json"));
    th = Object.assign(th, require("./000-000-0334/th.json"));
    zh = Object.assign(zh, require("./000-000-0334/zh.json"));
    pt = Object.assign(pt, require("./000-000-0334/pt.json"));
    tr = Object.assign(tr, require("./000-000-0334/tr.json"));
    ru = Object.assign(ru, require("./000-000-0334/ru.json"));
    es = Object.assign(es, require("./000-000-0334/es.json"));
    de = Object.assign(de, require("./000-000-0334/de.json"));
    ko = Object.assign(ko, require("./000-000-0334/ko.json"));
    ar = Object.assign(ar, require("./000-000-0334/ar.json"));
    my = Object.assign(my, require("./000-000-0334/my.json"));
    it = Object.assign(it, require("./000-000-0334/it.json"));
    vi = Object.assign(vi, require("./000-000-0334/vi.json"));
    he = Object.assign(he, require("./000-000-0334/he.json"));
    nl = Object.assign(nl, require("./000-000-0334/nl.json"));

    en = Object.assign(en, require("./000-000-0334/tos-en.json"));
    fr = Object.assign(fr, require("./000-000-0334/tos-fr.json"));
    ja = Object.assign(ja, require("./000-000-0334/tos-ja.json"));
    th = Object.assign(th, require("./000-000-0334/tos-th.json"));
    zh = Object.assign(zh, require("./000-000-0334/tos-zh.json"));
    pt = Object.assign(pt, require("./000-000-0334/tos-pt.json"));
    tr = Object.assign(tr, require("./000-000-0334/tos-tr.json"));
    ru = Object.assign(ru, require("./000-000-0334/tos-ru.json"));
    es = Object.assign(es, require("./000-000-0334/tos-es.json"));
    de = Object.assign(de, require("./000-000-0334/tos-de.json"));
    ko = Object.assign(ko, require("./000-000-0334/tos-ko.json"));
    ar = Object.assign(ar, require("./000-000-0334/tos-ar.json"));
    my = Object.assign(my, require("./000-000-0334/tos-my.json"));
    it = Object.assign(it, require("./000-000-0334/tos-it.json"));
    vi = Object.assign(vi, require("./000-000-0334/tos-vi.json"));
    he = Object.assign(he, require("./000-000-0334/tos-he.json"));
    nl = Object.assign(nl, require("./000-000-0334/tos-nl.json"));
  } else if (
    brand === "Centara Osaka" ||
    brand === "Centara Grand Hotel Osaka"
  ) {
    en = Object.assign(en, require("./000-000-0932/en.json"));
    fr = Object.assign(fr, require("./000-000-0932/fr.json"));
    ja = Object.assign(ja, require("./000-000-0932/ja.json"));
    th = Object.assign(th, require("./000-000-0932/th.json"));
    zh = Object.assign(zh, require("./000-000-0932/zh.json"));
    pt = Object.assign(pt, require("./000-000-0932/pt.json"));
    tr = Object.assign(tr, require("./000-000-0932/tr.json"));
    ru = Object.assign(ru, require("./000-000-0932/ru.json"));
    es = Object.assign(es, require("./000-000-0932/es.json"));
    de = Object.assign(de, require("./000-000-0932/de.json"));
    ko = Object.assign(ko, require("./000-000-0932/ko.json"));
    ar = Object.assign(ar, require("./000-000-0932/ar.json"));
    my = Object.assign(my, require("./000-000-0932/my.json"));
    it = Object.assign(it, require("./000-000-0932/it.json"));
    vi = Object.assign(vi, require("./000-000-0932/vi.json"));
    he = Object.assign(he, require("./000-000-0932/he.json"));
    nl = Object.assign(nl, require("./000-000-0932/nl.json"));

    en = Object.assign(en, require("./000-000-0932/tos-en.json"));
    fr = Object.assign(fr, require("./000-000-0932/tos-fr.json"));
    ja = Object.assign(ja, require("./000-000-0932/tos-ja.json"));
    th = Object.assign(th, require("./000-000-0932/tos-th.json"));
    zh = Object.assign(zh, require("./000-000-0932/tos-zh.json"));
    pt = Object.assign(pt, require("./000-000-0932/tos-pt.json"));
    tr = Object.assign(tr, require("./000-000-0932/tos-tr.json"));
    ru = Object.assign(ru, require("./000-000-0932/tos-ru.json"));
    es = Object.assign(es, require("./000-000-0932/tos-es.json"));
    de = Object.assign(de, require("./000-000-0932/tos-de.json"));
    ko = Object.assign(ko, require("./000-000-0932/tos-ko.json"));
    ar = Object.assign(ar, require("./000-000-0932/tos-ar.json"));
    my = Object.assign(my, require("./000-000-0932/tos-my.json"));
    it = Object.assign(it, require("./000-000-0932/tos-it.json"));
    vi = Object.assign(vi, require("./000-000-0932/tos-vi.json"));
    he = Object.assign(he, require("./000-000-0932/tos-he.json"));
    nl = Object.assign(nl, require("./000-000-0932/tos-nl.json"));
  } else if (brand === "OK TRAVEL") {
    en = Object.assign(en, require("./000-000-0763/en.json"));
    fr = Object.assign(fr, require("./000-000-0763/fr.json"));
    ja = Object.assign(ja, require("./000-000-0763/ja.json"));
    th = Object.assign(th, require("./000-000-0763/th.json"));
    zh = Object.assign(zh, require("./000-000-0763/zh.json"));
    pt = Object.assign(pt, require("./000-000-0763/pt.json"));
    tr = Object.assign(tr, require("./000-000-0763/tr.json"));
    ru = Object.assign(ru, require("./000-000-0763/ru.json"));
    es = Object.assign(es, require("./000-000-0763/es.json"));
    de = Object.assign(de, require("./000-000-0763/de.json"));
    ko = Object.assign(ko, require("./000-000-0763/ko.json"));
    ar = Object.assign(ar, require("./000-000-0763/ar.json"));
    my = Object.assign(my, require("./000-000-0763/my.json"));
    it = Object.assign(it, require("./000-000-0763/it.json"));
    vi = Object.assign(vi, require("./000-000-0763/vi.json"));
    he = Object.assign(he, require("./000-000-0763/he.json"));
    nl = Object.assign(nl, require("./000-000-0763/nl.json"));

    en = Object.assign(en, require("./000-000-0763/tos-en.json"));
    fr = Object.assign(fr, require("./000-000-0763/tos-fr.json"));
    ja = Object.assign(ja, require("./000-000-0763/tos-ja.json"));
    th = Object.assign(th, require("./000-000-0763/tos-th.json"));
    zh = Object.assign(zh, require("./000-000-0763/tos-zh.json"));
    pt = Object.assign(pt, require("./000-000-0763/tos-pt.json"));
    tr = Object.assign(tr, require("./000-000-0763/tos-tr.json"));
    ru = Object.assign(ru, require("./000-000-0763/tos-ru.json"));
    es = Object.assign(es, require("./000-000-0763/tos-es.json"));
    de = Object.assign(de, require("./000-000-0763/tos-de.json"));
    ko = Object.assign(ko, require("./000-000-0763/tos-ko.json"));
    ar = Object.assign(ar, require("./000-000-0763/tos-ar.json"));
    my = Object.assign(my, require("./000-000-0763/tos-my.json"));
    it = Object.assign(it, require("./000-000-0763/tos-it.json"));
    vi = Object.assign(vi, require("./000-000-0763/tos-vi.json"));
    he = Object.assign(he, require("./000-000-0763/tos-he.json"));
    nl = Object.assign(nl, require("./000-000-0763/tos-nl.json"));
  } else if (
    brand === "BOTANICAL POOL CLUB" ||
    brand === "VALM"
  ) {
    en = Object.assign(en, require("./000-000-0939/en.json"));
    fr = Object.assign(fr, require("./000-000-0939/fr.json"));
    ja = Object.assign(ja, require("./000-000-0939/ja.json"));
    th = Object.assign(th, require("./000-000-0939/th.json"));
    zh = Object.assign(zh, require("./000-000-0939/zh.json"));
    pt = Object.assign(pt, require("./000-000-0939/pt.json"));
    tr = Object.assign(tr, require("./000-000-0939/tr.json"));
    ru = Object.assign(ru, require("./000-000-0939/ru.json"));
    es = Object.assign(es, require("./000-000-0939/es.json"));
    de = Object.assign(de, require("./000-000-0939/de.json"));
    ko = Object.assign(ko, require("./000-000-0939/ko.json"));
    ar = Object.assign(ar, require("./000-000-0939/ar.json"));
    my = Object.assign(my, require("./000-000-0939/my.json"));
    it = Object.assign(it, require("./000-000-0939/it.json"));
    vi = Object.assign(vi, require("./000-000-0939/vi.json"));
    he = Object.assign(he, require("./000-000-0939/he.json"));
    nl = Object.assign(nl, require("./000-000-0939/nl.json"));

    en = Object.assign(en, require("./000-000-0939/tos-en.json"));
    fr = Object.assign(fr, require("./000-000-0939/tos-fr.json"));
    ja = Object.assign(ja, require("./000-000-0939/tos-ja.json"));
    th = Object.assign(th, require("./000-000-0939/tos-th.json"));
    zh = Object.assign(zh, require("./000-000-0939/tos-zh.json"));
    pt = Object.assign(pt, require("./000-000-0939/tos-pt.json"));
    tr = Object.assign(tr, require("./000-000-0939/tos-tr.json"));
    ru = Object.assign(ru, require("./000-000-0939/tos-ru.json"));
    es = Object.assign(es, require("./000-000-0939/tos-es.json"));
    de = Object.assign(de, require("./000-000-0939/tos-de.json"));
    ko = Object.assign(ko, require("./000-000-0939/tos-ko.json"));
    ar = Object.assign(ar, require("./000-000-0939/tos-ar.json"));
    my = Object.assign(my, require("./000-000-0939/tos-my.json"));
    it = Object.assign(it, require("./000-000-0939/tos-it.json"));
    vi = Object.assign(vi, require("./000-000-0939/tos-vi.json"));
    he = Object.assign(he, require("./000-000-0939/tos-he.json"));
    nl = Object.assign(nl, require("./000-000-0939/tos-nl.json"));
  } else if (brand === "Janu") {
    en = Object.assign(en, require("./000-000-0335/en.json"));
    fr = Object.assign(fr, require("./000-000-0335/fr.json"));
    ja = Object.assign(ja, require("./000-000-0335/ja.json"));
    th = Object.assign(th, require("./000-000-0335/th.json"));
    zh = Object.assign(zh, require("./000-000-0335/zh.json"));
    pt = Object.assign(pt, require("./000-000-0335/pt.json"));
    tr = Object.assign(tr, require("./000-000-0335/tr.json"));
    ru = Object.assign(ru, require("./000-000-0335/ru.json"));
    es = Object.assign(es, require("./000-000-0335/es.json"));
    de = Object.assign(de, require("./000-000-0335/de.json"));
    ko = Object.assign(ko, require("./000-000-0335/ko.json"));
    ar = Object.assign(ar, require("./000-000-0335/ar.json"));
    my = Object.assign(my, require("./000-000-0335/my.json"));
    it = Object.assign(it, require("./000-000-0335/it.json"));
    vi = Object.assign(vi, require("./000-000-0335/vi.json"));
    he = Object.assign(he, require("./000-000-0335/he.json"));
    nl = Object.assign(nl, require("./000-000-0335/nl.json"));

    en = Object.assign(en, require("./000-000-0335/tos-en.json"));
    fr = Object.assign(fr, require("./000-000-0335/tos-fr.json"));
    ja = Object.assign(ja, require("./000-000-0335/tos-ja.json"));
    th = Object.assign(th, require("./000-000-0335/tos-th.json"));
    zh = Object.assign(zh, require("./000-000-0335/tos-zh.json"));
    pt = Object.assign(pt, require("./000-000-0335/tos-pt.json"));
    tr = Object.assign(tr, require("./000-000-0335/tos-tr.json"));
    ru = Object.assign(ru, require("./000-000-0335/tos-ru.json"));
    es = Object.assign(es, require("./000-000-0335/tos-es.json"));
    de = Object.assign(de, require("./000-000-0335/tos-de.json"));
    ko = Object.assign(ko, require("./000-000-0335/tos-ko.json"));
    ar = Object.assign(ar, require("./000-000-0335/tos-ar.json"));
    my = Object.assign(my, require("./000-000-0335/tos-my.json"));
    it = Object.assign(it, require("./000-000-0335/tos-it.json"));
    vi = Object.assign(vi, require("./000-000-0335/tos-vi.json"));
    he = Object.assign(he, require("./000-000-0335/tos-he.json"));
    nl = Object.assign(nl, require("./000-000-0335/tos-nl.json"));
  } else if (brand === "Elite Havens") {
    en = Object.assign(en, require("./ELITEHAVENS/en.json"));
    fr = Object.assign(fr, require("./ELITEHAVENS/fr.json"));
    ja = Object.assign(ja, require("./ELITEHAVENS/ja.json"));
    th = Object.assign(th, require("./ELITEHAVENS/th.json"));
    zh = Object.assign(zh, require("./ELITEHAVENS/zh.json"));
    pt = Object.assign(pt, require("./ELITEHAVENS/pt.json"));
    tr = Object.assign(tr, require("./ELITEHAVENS/tr.json"));
    ru = Object.assign(ru, require("./ELITEHAVENS/ru.json"));
    es = Object.assign(es, require("./ELITEHAVENS/es.json"));
    de = Object.assign(de, require("./ELITEHAVENS/de.json"));
    ko = Object.assign(ko, require("./ELITEHAVENS/ko.json"));
    ar = Object.assign(ar, require("./ELITEHAVENS/ar.json"));
    my = Object.assign(my, require("./ELITEHAVENS/my.json"));
    it = Object.assign(it, require("./ELITEHAVENS/it.json"));
    vi = Object.assign(vi, require("./ELITEHAVENS/vi.json"));
    he = Object.assign(he, require("./ELITEHAVENS/he.json"));
    nl = Object.assign(nl, require("./ELITEHAVENS/nl.json"));

    en = Object.assign(en, require("./ELITEHAVENS/tos-en.json"));
    fr = Object.assign(fr, require("./ELITEHAVENS/tos-fr.json"));
    ja = Object.assign(ja, require("./ELITEHAVENS/tos-ja.json"));
    th = Object.assign(th, require("./ELITEHAVENS/tos-th.json"));
    zh = Object.assign(zh, require("./ELITEHAVENS/tos-zh.json"));
    pt = Object.assign(pt, require("./ELITEHAVENS/tos-pt.json"));
    tr = Object.assign(tr, require("./ELITEHAVENS/tos-tr.json"));
    ru = Object.assign(ru, require("./ELITEHAVENS/tos-ru.json"));
    es = Object.assign(es, require("./ELITEHAVENS/tos-es.json"));
    de = Object.assign(de, require("./ELITEHAVENS/tos-de.json"));
    ko = Object.assign(ko, require("./ELITEHAVENS/tos-ko.json"));
    ar = Object.assign(ar, require("./ELITEHAVENS/tos-ar.json"));
    my = Object.assign(my, require("./ELITEHAVENS/tos-my.json"));
    it = Object.assign(it, require("./ELITEHAVENS/tos-it.json"));
    vi = Object.assign(vi, require("./ELITEHAVENS/tos-vi.json"));
    he = Object.assign(he, require("./ELITEHAVENS/tos-he.json"));
    nl = Object.assign(nl, require("./ELITEHAVENS/tos-nl.json"));
  } else if (
    brand === "Dusit" ||
    brand === "Dusit Hotels & Resort"
  ) {
    en = Object.assign(en, require("./DUSIT/en.json"));
    fr = Object.assign(fr, require("./DUSIT/fr.json"));
    ja = Object.assign(ja, require("./DUSIT/ja.json"));
    th = Object.assign(th, require("./DUSIT/th.json"));
    zh = Object.assign(zh, require("./DUSIT/zh.json"));
    pt = Object.assign(pt, require("./DUSIT/pt.json"));
    tr = Object.assign(tr, require("./DUSIT/tr.json"));
    ru = Object.assign(ru, require("./DUSIT/ru.json"));
    es = Object.assign(es, require("./DUSIT/es.json"));
    de = Object.assign(de, require("./DUSIT/de.json"));
    ko = Object.assign(ko, require("./DUSIT/ko.json"));
    ar = Object.assign(ar, require("./DUSIT/ar.json"));
    my = Object.assign(my, require("./DUSIT/my.json"));
    it = Object.assign(it, require("./DUSIT/it.json"));
    vi = Object.assign(vi, require("./DUSIT/vi.json"));
    he = Object.assign(he, require("./DUSIT/he.json"));
    nl = Object.assign(nl, require("./DUSIT/nl.json"));

    en = Object.assign(en, require("./DUSIT/tos-en.json"));
    fr = Object.assign(fr, require("./DUSIT/tos-fr.json"));
    ja = Object.assign(ja, require("./DUSIT/tos-ja.json"));
    th = Object.assign(th, require("./DUSIT/tos-th.json"));
    zh = Object.assign(zh, require("./DUSIT/tos-zh.json"));
    pt = Object.assign(pt, require("./DUSIT/tos-pt.json"));
    tr = Object.assign(tr, require("./DUSIT/tos-tr.json"));
    ru = Object.assign(ru, require("./DUSIT/tos-ru.json"));
    es = Object.assign(es, require("./DUSIT/tos-es.json"));
    de = Object.assign(de, require("./DUSIT/tos-de.json"));
    ko = Object.assign(ko, require("./DUSIT/tos-ko.json"));
    ar = Object.assign(ar, require("./DUSIT/tos-ar.json"));
    my = Object.assign(my, require("./DUSIT/tos-my.json"));
    it = Object.assign(it, require("./DUSIT/tos-it.json"));
    vi = Object.assign(vi, require("./DUSIT/tos-vi.json"));
    he = Object.assign(he, require("./DUSIT/tos-he.json"));
    nl = Object.assign(nl, require("./DUSIT/tos-nl.json"));
  } else if (brand === "OK Residential") {
    en = Object.assign(en, require("./000-000-0761/en.json"));
    fr = Object.assign(fr, require("./000-000-0761/fr.json"));
    ja = Object.assign(ja, require("./000-000-0761/ja.json"));
    th = Object.assign(th, require("./000-000-0761/th.json"));
    zh = Object.assign(zh, require("./000-000-0761/zh.json"));
    pt = Object.assign(pt, require("./000-000-0761/pt.json"));
    tr = Object.assign(tr, require("./000-000-0761/tr.json"));
    ru = Object.assign(ru, require("./000-000-0761/ru.json"));
    es = Object.assign(es, require("./000-000-0761/es.json"));
    de = Object.assign(de, require("./000-000-0761/de.json"));
    ko = Object.assign(ko, require("./000-000-0761/ko.json"));
    ar = Object.assign(ar, require("./000-000-0761/ar.json"));
    my = Object.assign(my, require("./000-000-0761/my.json"));
    it = Object.assign(it, require("./000-000-0761/it.json"));
    vi = Object.assign(vi, require("./000-000-0761/vi.json"));
    he = Object.assign(he, require("./000-000-0761/he.json"));
    nl = Object.assign(nl, require("./000-000-0761/nl.json"));

    en = Object.assign(en, require("./000-000-0761/tos-en.json"));
    fr = Object.assign(fr, require("./000-000-0761/tos-fr.json"));
    ja = Object.assign(ja, require("./000-000-0761/tos-ja.json"));
    th = Object.assign(th, require("./000-000-0761/tos-th.json"));
    zh = Object.assign(zh, require("./000-000-0761/tos-zh.json"));
    pt = Object.assign(pt, require("./000-000-0761/tos-pt.json"));
    tr = Object.assign(tr, require("./000-000-0761/tos-tr.json"));
    ru = Object.assign(ru, require("./000-000-0761/tos-ru.json"));
    es = Object.assign(es, require("./000-000-0761/tos-es.json"));
    de = Object.assign(de, require("./000-000-0761/tos-de.json"));
    ko = Object.assign(ko, require("./000-000-0761/tos-ko.json"));
    ar = Object.assign(ar, require("./000-000-0761/tos-ar.json"));
    my = Object.assign(my, require("./000-000-0761/tos-my.json"));
    it = Object.assign(it, require("./000-000-0761/tos-it.json"));
    vi = Object.assign(vi, require("./000-000-0761/tos-vi.json"));
    he = Object.assign(he, require("./000-000-0761/tos-he.json"));
    nl = Object.assign(nl, require("./000-000-0761/tos-nl.json"));
  } else if (brand === "Adventure Park") {
    en = Object.assign(en, require("./ADVENTUREPARK/en.json"));
    fr = Object.assign(fr, require("./ADVENTUREPARK/fr.json"));
    ja = Object.assign(ja, require("./ADVENTUREPARK/ja.json"));
    th = Object.assign(th, require("./ADVENTUREPARK/th.json"));
    zh = Object.assign(zh, require("./ADVENTUREPARK/zh.json"));
    pt = Object.assign(pt, require("./ADVENTUREPARK/pt.json"));
    tr = Object.assign(tr, require("./ADVENTUREPARK/tr.json"));
    ru = Object.assign(ru, require("./ADVENTUREPARK/ru.json"));
    es = Object.assign(es, require("./ADVENTUREPARK/es.json"));
    de = Object.assign(de, require("./ADVENTUREPARK/de.json"));
    ko = Object.assign(ko, require("./ADVENTUREPARK/ko.json"));
    ar = Object.assign(ar, require("./ADVENTUREPARK/ar.json"));
    my = Object.assign(my, require("./ADVENTUREPARK/my.json"));
    it = Object.assign(it, require("./ADVENTUREPARK/it.json"));
    vi = Object.assign(vi, require("./ADVENTUREPARK/vi.json"));
    he = Object.assign(he, require("./ADVENTUREPARK/he.json"));
    nl = Object.assign(nl, require("./ADVENTUREPARK/nl.json"));

    en = Object.assign(en, require("./ADVENTUREPARK/tos-en.json"));
    fr = Object.assign(fr, require("./ADVENTUREPARK/tos-fr.json"));
    ja = Object.assign(ja, require("./ADVENTUREPARK/tos-ja.json"));
    th = Object.assign(th, require("./ADVENTUREPARK/tos-th.json"));
    zh = Object.assign(zh, require("./ADVENTUREPARK/tos-zh.json"));
    pt = Object.assign(pt, require("./ADVENTUREPARK/tos-pt.json"));
    tr = Object.assign(tr, require("./ADVENTUREPARK/tos-tr.json"));
    ru = Object.assign(ru, require("./ADVENTUREPARK/tos-ru.json"));
    es = Object.assign(es, require("./ADVENTUREPARK/tos-es.json"));
    de = Object.assign(de, require("./ADVENTUREPARK/tos-de.json"));
    ko = Object.assign(ko, require("./ADVENTUREPARK/tos-ko.json"));
    ar = Object.assign(ar, require("./ADVENTUREPARK/tos-ar.json"));
    my = Object.assign(my, require("./ADVENTUREPARK/tos-my.json"));
    it = Object.assign(it, require("./ADVENTUREPARK/tos-it.json"));
    vi = Object.assign(vi, require("./ADVENTUREPARK/tos-vi.json"));
    he = Object.assign(he, require("./ADVENTUREPARK/tos-he.json"));
    nl = Object.assign(nl, require("./ADVENTUREPARK/tos-nl.json"));
  } else if (brand === "Mulia Hotels") {
    en = Object.assign(en, require("./MULIA/en.json"));
    fr = Object.assign(fr, require("./MULIA/fr.json"));
    ja = Object.assign(ja, require("./MULIA/ja.json"));
    th = Object.assign(th, require("./MULIA/th.json"));
    zh = Object.assign(zh, require("./MULIA/zh.json"));
    pt = Object.assign(pt, require("./MULIA/pt.json"));
    tr = Object.assign(tr, require("./MULIA/tr.json"));
    ru = Object.assign(ru, require("./MULIA/ru.json"));
    es = Object.assign(es, require("./MULIA/es.json"));
    de = Object.assign(de, require("./MULIA/de.json"));
    ko = Object.assign(ko, require("./MULIA/ko.json"));
    ar = Object.assign(ar, require("./MULIA/ar.json"));
    my = Object.assign(my, require("./MULIA/my.json"));
    it = Object.assign(it, require("./MULIA/it.json"));
    vi = Object.assign(vi, require("./MULIA/vi.json"));
    he = Object.assign(he, require("./MULIA/he.json"));
    nl = Object.assign(nl, require("./MULIA/nl.json"));

    en = Object.assign(en, require("./MULIA/tos-en.json"));
    fr = Object.assign(fr, require("./MULIA/tos-fr.json"));
    ja = Object.assign(ja, require("./MULIA/tos-ja.json"));
    th = Object.assign(th, require("./MULIA/tos-th.json"));
    zh = Object.assign(zh, require("./MULIA/tos-zh.json"));
    pt = Object.assign(pt, require("./MULIA/tos-pt.json"));
    tr = Object.assign(tr, require("./MULIA/tos-tr.json"));
    ru = Object.assign(ru, require("./MULIA/tos-ru.json"));
    es = Object.assign(es, require("./MULIA/tos-es.json"));
    de = Object.assign(de, require("./MULIA/tos-de.json"));
    ko = Object.assign(ko, require("./MULIA/tos-ko.json"));
    ar = Object.assign(ar, require("./MULIA/tos-ar.json"));
    my = Object.assign(my, require("./MULIA/tos-my.json"));
    it = Object.assign(it, require("./MULIA/tos-it.json"));
    vi = Object.assign(vi, require("./MULIA/tos-vi.json"));
    he = Object.assign(he, require("./MULIA/tos-he.json"));
    nl = Object.assign(nl, require("./MULIA/tos-nl.json"));
  } else if (brand === "Pathumwan Princess") {
    en = Object.assign(en, require("./PATHUMWANPRINCESS/en.json"));
    fr = Object.assign(fr, require("./PATHUMWANPRINCESS/fr.json"));
    ja = Object.assign(ja, require("./PATHUMWANPRINCESS/ja.json"));
    th = Object.assign(th, require("./PATHUMWANPRINCESS/th.json"));
    zh = Object.assign(zh, require("./PATHUMWANPRINCESS/zh.json"));
    pt = Object.assign(pt, require("./PATHUMWANPRINCESS/pt.json"));
    tr = Object.assign(tr, require("./PATHUMWANPRINCESS/tr.json"));
    ru = Object.assign(ru, require("./PATHUMWANPRINCESS/ru.json"));
    es = Object.assign(es, require("./PATHUMWANPRINCESS/es.json"));
    de = Object.assign(de, require("./PATHUMWANPRINCESS/de.json"));
    ko = Object.assign(ko, require("./PATHUMWANPRINCESS/ko.json"));
    ar = Object.assign(ar, require("./PATHUMWANPRINCESS/ar.json"));
    my = Object.assign(my, require("./PATHUMWANPRINCESS/my.json"));
    it = Object.assign(it, require("./PATHUMWANPRINCESS/it.json"));
    vi = Object.assign(vi, require("./PATHUMWANPRINCESS/vi.json"));
    he = Object.assign(he, require("./PATHUMWANPRINCESS/he.json"));
    nl = Object.assign(nl, require("./PATHUMWANPRINCESS/nl.json"));

    en = Object.assign(en, require("./PATHUMWANPRINCESS/tos-en.json"));
    fr = Object.assign(fr, require("./PATHUMWANPRINCESS/tos-fr.json"));
    ja = Object.assign(ja, require("./PATHUMWANPRINCESS/tos-ja.json"));
    th = Object.assign(th, require("./PATHUMWANPRINCESS/tos-th.json"));
    zh = Object.assign(zh, require("./PATHUMWANPRINCESS/tos-zh.json"));
    pt = Object.assign(pt, require("./PATHUMWANPRINCESS/tos-pt.json"));
    tr = Object.assign(tr, require("./PATHUMWANPRINCESS/tos-tr.json"));
    ru = Object.assign(ru, require("./PATHUMWANPRINCESS/tos-ru.json"));
    es = Object.assign(es, require("./PATHUMWANPRINCESS/tos-es.json"));
    de = Object.assign(de, require("./PATHUMWANPRINCESS/tos-de.json"));
    ko = Object.assign(ko, require("./PATHUMWANPRINCESS/tos-ko.json"));
    ar = Object.assign(ar, require("./PATHUMWANPRINCESS/tos-ar.json"));
    my = Object.assign(my, require("./PATHUMWANPRINCESS/tos-my.json"));
    it = Object.assign(it, require("./PATHUMWANPRINCESS/tos-it.json"));
    vi = Object.assign(vi, require("./PATHUMWANPRINCESS/tos-vi.json"));
    he = Object.assign(he, require("./PATHUMWANPRINCESS/tos-he.json"));
    nl = Object.assign(nl, require("./PATHUMWANPRINCESS/tos-nl.json"));
  } else if (brand === "Real Time Venue") {
    en = Object.assign(en, require("./REALTIMEVENUE/en.json"));
    fr = Object.assign(fr, require("./REALTIMEVENUE/fr.json"));
    ja = Object.assign(ja, require("./REALTIMEVENUE/ja.json"));
    th = Object.assign(th, require("./REALTIMEVENUE/th.json"));
    zh = Object.assign(zh, require("./REALTIMEVENUE/zh.json"));
    pt = Object.assign(pt, require("./REALTIMEVENUE/pt.json"));
    tr = Object.assign(tr, require("./REALTIMEVENUE/tr.json"));
    ru = Object.assign(ru, require("./REALTIMEVENUE/ru.json"));
    es = Object.assign(es, require("./REALTIMEVENUE/es.json"));
    de = Object.assign(de, require("./REALTIMEVENUE/de.json"));
    ko = Object.assign(ko, require("./REALTIMEVENUE/ko.json"));
    ar = Object.assign(ar, require("./REALTIMEVENUE/ar.json"));
    my = Object.assign(my, require("./REALTIMEVENUE/my.json"));
    it = Object.assign(it, require("./REALTIMEVENUE/it.json"));
    vi = Object.assign(vi, require("./REALTIMEVENUE/vi.json"));
    he = Object.assign(he, require("./REALTIMEVENUE/he.json"));
    nl = Object.assign(nl, require("./REALTIMEVENUE/nl.json"));

    en = Object.assign(en, require("./REALTIMEVENUE/tos-en.json"));
    fr = Object.assign(fr, require("./REALTIMEVENUE/tos-fr.json"));
    ja = Object.assign(ja, require("./REALTIMEVENUE/tos-ja.json"));
    th = Object.assign(th, require("./REALTIMEVENUE/tos-th.json"));
    zh = Object.assign(zh, require("./REALTIMEVENUE/tos-zh.json"));
    pt = Object.assign(pt, require("./REALTIMEVENUE/tos-pt.json"));
    tr = Object.assign(tr, require("./REALTIMEVENUE/tos-tr.json"));
    ru = Object.assign(ru, require("./REALTIMEVENUE/tos-ru.json"));
    es = Object.assign(es, require("./REALTIMEVENUE/tos-es.json"));
    de = Object.assign(de, require("./REALTIMEVENUE/tos-de.json"));
    ko = Object.assign(ko, require("./REALTIMEVENUE/tos-ko.json"));
    ar = Object.assign(ar, require("./REALTIMEVENUE/tos-ar.json"));
    my = Object.assign(my, require("./REALTIMEVENUE/tos-my.json"));
    it = Object.assign(it, require("./REALTIMEVENUE/tos-it.json"));
    vi = Object.assign(vi, require("./REALTIMEVENUE/tos-vi.json"));
    he = Object.assign(he, require("./REALTIMEVENUE/tos-he.json"));
    nl = Object.assign(nl, require("./REALTIMEVENUE/tos-nl.json"));
  }

  const Resources = {
    en: { translation: en },
    de: { translation: de },
    ar: { translation: ar },
    es: { translation: es },
    fr: { translation: fr },
    he: { translation: he },
    it: { translation: it },
    ja: { translation: ja },
    ko: { translation: ko },
    my: { translation: my },
    pt: { translation: pt },
    ru: { translation: ru },
    th: { translation: th },
    tr: { translation: tr },
    vi: { translation: vi },
    zh: { translation: zh },
    nl: { translation: nl },
  };

  return Resources;
};

export default useGetBrandTranslation;
